const mainStores = [
  {
    name: "GIVA - 1 MG Lido Mall",
    address:
      "\n      1 Mg, Mall, opp. vivanta by taj trinity circle, Halasuru, Someshwarpura, Sivanchetti Gardens, Bengaluru, Karnataka\n      560008\n    ",
    phone: "+91 6360134465",
    storeId: "66203910306",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+1MG+Lido+Mall,+1+Mg,+Mall,+opp.+vivanta+by+taj+trinity+circle,+Halasuru,+Someshwarpura,+Sivanchetti+Gardens,+Bengaluru,+Karnataka+560008/@12.9735941,77.6204453,17z/data=!3m1!5s0x3bae169ca347c26d:0xa894488bbfedf10c!4m8!4m7!1m0!1m5!1m1!1s0x3bae17582ba9f2dd:0xaed22e08adf6c633!2m2!1d77.6204453!2d12.9735941?hl=en-GB",
  },
  {
    name: "GIVA - Kothrud HS",
    address:
      "\n      GIVA jewellery store, Success Square, Karve Road 157/A/B/C, near Karve Statue, opp. Sheetal Restaurant, Pune,\n      Maharashtra 411038\n    ",
    phone: "+91 8310183384",
    storeId: "68029087906",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA,+Shop+no,+GIVA+-+Pune+-+Kothrud,+10%2F11,+Success+Square,+Karve+Statue,+Karve+Rd,+Kothrud,+Pune,+Maharashtra+411038/@18.5019538,73.8166342,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bc2bf84a86ce1cf:0x24427fb19b5df3cf!2m2!1d73.8166342!2d18.5019538!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Camac Street HS",
    address: "GIVA ,24 Camac street, Camac Square, Near Vaardan Market",
    phone: "+91 6360097562",
    storeId: "68024631458",
    gmapLink:
      "https://www.google.com/maps/dir//Ground+floor,+GIVA+-+Camac+Street,+GIVA,+Camac+Square,+24,+Camac+St,+near+Vaardan+market,+opp.+hp+petrol+station,+Kankaria+Estates,+Park+Street+area,+Kolkata,+West+Bengal+700016/@22.5476394,88.3535064,15z/data=!3m1!5s0x3a027710b0005ff3:0x58e4e3e35b8734b0!4m9!4m8!1m0!1m5!1m1!1s0x3a02777d763b2255:0xe52509fc4abf9ea7!2m2!1d88.3535064!2d22.5476394!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - DSL Virtue Mall",
    address:
      "\n      Shop No - UGF-04,Upper ground floor.Hyderabad - Warangal Hwy, Near Rajiv Gandhi International Cricket Stadium,\n      Hyderabad, Industrial Development Area, Uppal, Hyderabad, Telangana 500039\n    ",
    phone: "+91 8420734283",
    storeId: "67976429730",
    gmapLink:
      "https://www.google.com/maps/dir//UGF+-+04,+Upper+Ground+Floor,+GIVA+-+Hyderabad+-+DSL+Virtue+Mall,+DSL+Virtue+Mall,+Hyderabad+-+Warangal+Hwy,+near+Rajiv+Gandhi+International+Cricket+Stadium,+IDA+Uppal,+Uppal,+Hyderabad,+Telangana+500039/@17.4004071,78.5549473,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bcb99aef9e8288d:0x28a80801b2a7051e!2m2!1d78.5549473!2d17.4004071!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Musarambagh Mall",
    address:
      "Giva ,Next Galleria Mall Level 2,15, NH 65, Andhra Colony, New Malakpet, Hyderabad, Telangana 500036",
    phone: "+91 6360096621",
    storeId: "67978625186",
    gmapLink:
      "https://www.google.com/maps/dir//Ward+No.+170,+GIVA+-+Hyderabad+-+Next+Galleria+Mall,+Musarambagh,+Block-B,+GaddiAnnaram+Saidabad,+GIVA,+L2-13,+Level+2,+Next+Galleria+Mall+Adjacent+to+Musarambagh+Metro+Station,+Moosarambagh,+Hyderabad,+Telangana+500036/@17.3951808,78.5298363,15z/data=!3m1!5s0x3bcb990564b997bd:0xfcd71cdfa421f114!4m9!4m8!1m0!1m5!1m1!1s0x3bcb996105c16a7b:0xbf2d673b8ed40ac5!2m2!1d78.5096348!2d17.3716238!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Mulund West HS",
    address:
      "\n      Giva,Shop No-12,Runwel Anthurium,Old Gabriel Factory,Opp Veena Nagar,Lbs Road,Mulund West,Lal Bahadur Shastri Rd,\n      Vardhman Nagar,Mulund West, Mumbai,400080\n    ",
    phone: "+91 8660699940",
    storeId: "68026794146",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+shop+no:12,+GIVA+-+Mumbai+-+Mulund,+Runwal+Anthurium,+old+Gabriel+factory,+Lal+Bahadur+Shastri+Marg,+opp.+veena+nagar,+Vardhman+Nagar,+Mulund+West,+Mumbai,+Maharashtra+400080/@19.1807445,72.9467345,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3be7b982b27811df:0x612f15e1e0b727b!2m2!1d72.9467345!2d19.1807445!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Pacific Mall, NSP",
    address:
      "\n      Shop no:SH1F26 &amp; SH1F27, First floor, Pacific Mall Netaji Subhash place,, DMRC Phase III Corridor, Pitampura, New\n      Delhi, Delhi 110034\n    ",
    phone: "+91 8310183482",
    storeId: "68002939042",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+no:SH1F26+%26+SH1F27,+First+floor,+GIVA+-+Delhi+-+Pacific+NSP,+Pacific+Mall,+DMRC+Phase+III+Corridor,+Netaji+Subhash+Place,+Pitampura,+New+Delhi,+Delhi,+110034/@28.694249,77.1535914,15z/data=!3m1!5s0x390d0233d3fbf2df:0xb1f62c6274af0ba8!4m9!4m8!1m0!1m5!1m1!1s0x390d0300556f99c7:0x7cfd84aa2a50f357!2m2!1d77.1536045!2d28.6942813!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Nexus Ahmedabad",
    address:
      "Nexus One Ahmedabad Unit No. F 25, Plot No. 216, T.P. Scheme-01,Near Vastrapur Lake, Ahmedabad,Gujarat-380054",
    phone: "+91 8310183546",
    storeId: "68066967714",
    gmapLink:
      "https://www.google.com/maps/dir//Plot+No.+216,+GIVA+-+Nexus+One+Mall+-+Ahmedabad,+T.P.+Scheme-01,+Nexus+One,+Giva,+Unit+No,+F+25,+Lake,+near+Vastrapur,+Ahmedabad,+Gujarat+380054/@23.0396611,72.5315696,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x395e859daac00db7:0x420f47c1bdb950b!2m2!1d72.5315696!2d23.0396611!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Mall of Asia",
    address:
      "Giva, S-37, 2nd floor, 239/240, Mall of Asia, Byatarayanapura, Yelahanka, Bangalore, Karnataka 560092",
    phone: "+91 9019923626",
    storeId: "68053041314",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+S-37,+2nd+floor,+GIVA+-+Bangalore+-+Mall+of+Asia,+Mall+of+Asia,+239%2F240,+Indra+Nagar,+Sahakar+Nagar,+Yelahanka,+Byatarayanapura+CMC+and+OG+Part,+Bengaluru,+Karnataka+560092/@13.0709039,77.5904774,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae195fed49c40f:0x2b2972e1d4e9118b!2m2!1d77.5904774!2d13.0709039!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Banashankari",
    address:
      "No. 13, 100 feet ring road, 3Rd stage, Banashankari, bengaluru- 560085",
    phone: "+91 8310183477",
    storeId: "68024565922",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+GIVA+-+Bangalore+-+Banashankari,+No:13,+100+feet+ring+road,+next+to+Bata,+3rd+Phase,+Phase+3,+Banashankari,+Bengaluru,+Karnataka+560085/@12.9076596,77.5709657,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae15497f2613bf:0xc9b6824b94878892!2m2!1d77.5507311!2d12.9251626!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Dickenson Road",
    address:
      "\n      Giva, 44/5, Dickenson Rd, Yellappa Garden, Yellappa Chetty Layout, Sivanchetti Gardens, Bengaluru, Karnataka\n      560042\n    ",
    phone: "+91 6360099301",
    storeId: "68057694370",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+44%2F5,+GIVA+-+Bangalore+-+Dickenson+Road,+Dickenson+Rd,+Yellappa+Garden,+Yellappa+Chetty+Layout,+Sivanchetti+Gardens,+Bengaluru,+Karnataka+560042/@12.9756032,77.6144403,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae176fd0cea9b3:0x8f24d2fbbfbae1d3!2m2!1d77.6144403!2d12.9756032!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - GMS Dehradun HS",
    address:
      "\n      Giva fine silver jewellery shreeji tower, Opposite Bharat Gas Agency, General Mahadev Singh Rd, Kaonli, Dehradun,\n      Uttarakhand 248146\n    ",
    phone: "+91 8217597126",
    storeId: "68046323874",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA,+GIVA+-+Dehradun+-+GMS+Road,+Shreeji+Towers,+General+Mahadev+Singh+Rd,+near+Chaudhary+Farm+House,+opp.+Bharat+Gas+Agency,+Shakti+Enclave,+Kaonli,+Dehradun,+Uttarakhand+248146/@30.3178611,78.0122002,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x39092b458385d97b:0x92508efc7a0fcea2!2m2!1d78.0122002!2d30.3178611!3e0?entry=ttu",
  },
  {
    name: "GIVA - Kankarbagh HS",
    address:
      "GIVA Ground Floor Janki Bhavan Below Sumit &amp; Sharma sports. Kankarbagh Main Road.",
    phone: "+91 6360098422",
    storeId: "68054843554",
    gmapLink:
      "https://www.google.com/maps/dir//Ward+No+35,+GIVA+-+Patna+-+Kankarbagh,+Circle+8A,+GIVA,+Ground+floor,+Janki+Bhavan,+Kankarbagh+Main+Rd,+beside+Manyavar+showroom,+Patna,+Bihar+800001/@25.6030659,85.1558106,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x39ed5971a0336687:0xd2e35ef399012b42!2m2!1d85.1558106!2d25.6030659!3e0?entry=ttu",
  },
  {
    name: "GIVA Jayanagar 2",
    address:
      "Shop no 104,68/1,11th main road, 4th block,jayanagar bengaluru-560041",
    phone: "+91 8217596480",
    storeId: "68084596898",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA,+Shop+no:104,+GIVA+-+Bangalore+-+Jayanagar2,+68%2F1,+11th+Main+Rd,+opp.+vijaya+pu+college,+4th+T+Block+East,+4th+Block,+Jayanagar,+Bengaluru,+Karnataka+560041/@12.9281442,77.5861349,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae156056cb0dd7:0xd9204e65d3c4f9c9!2m2!1d77.5861349!2d12.9281442!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - VR Surat",
    address:
      "Unit No. GF22, VR SURAT,Dumas Rd,New Magdalla, Surat,Gujarat 395007",
    phone: "+91 6360096498",
    storeId: "68066934946",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+Unit+No:+GF22,+GIVA+-+Surat+-+VR+Mall,+VR,+Surat+-+Dumas+Rd,+New+Magdalla,+Surat,+Gujarat+395007/@21.1447455,72.7576097,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3be053a6998cb5e3:0x44b0882cc41660a3!2m2!1d72.7576097!2d21.1447455!3e0?entry=ttu",
  },
  {
    name: "GIVA - Indore HS",
    address:
      "\n      Giva , plot no. 16 , sapphire twins, AB road, opp. Malhar mall, near bandhan bank, indore madhya pradesh 452010\n    ",
    phone: "+91 9019608262",
    storeId: "68029743266",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA,+Plot+no:16,+GIVA+-+AB+road,+Indore,+Sapphire+twins,+AB+Rd,+opp.+Malhar+mall,+near+bandan+bank,+Opposite+C-21+Mall,+Scheme+No+54,+Indore,+Madhya+Pradesh+452010/@22.7448825,75.8933179,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3962fd373008add5:0xbee736b44d86bc73!2m2!1d75.8933179!2d22.7448825!3e0?entry=ttu",
  },
  {
    name: "GIVA - PMC Pune",
    address:
      "Unit no. F-52A, Survey Number 207, Viman Nagar Road, Pune- 411014",
    phone: "+91 8310183506",
    storeId: "67992420514",
    gmapLink:
      "https://www.google.com/maps/dir//18.5622128,73.9171825/@18.5622128,73.9149938,17z?hl=en",
  },
  {
    name: "GIVA - Bel Road HS",
    address:
      "\n      GIVA, SRK building no 197, Ground floor, Devasandra, New BEL Road, opposite Peter England Showroom, Bengaluru,\n      Karnataka 560094\n    ",
    phone: "+91 8310183595",
    storeId: "68002971810",
    gmapLink:
      "https://www.google.com/maps/dir//no+197,+Ground+floor,+GIVA+-+Bel+Road,+SRK+building,+GIVA,+New+BEL+Rd,+opposite+Peter+England+showroom,+Devasandra+Layout,+Bengaluru,+Karnataka+560094/@13.0298918,77.570853,15z/data=!3m1!5s0x3bae17dc91708ef3:0x11841fd79913b35b!4m8!4m7!1m0!1m5!1m1!1s0x3bae17eb06d6e235:0xdfc7cc25dbf05190!2m2!1d77.570853!2d13.0298918?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Sampige Road HS",
    address:
      "Giva, Ground floor, Building no : 524, 2nd main, Sampige road, Malleshwaram, Bangalore, 560003",
    phone: "+91 8660699934",
    storeId: "68019650722",
    gmapLink:
      "https://www.google.com/maps/dir//Ground+floor,+building+no:524,+GIVA+-+Bangalore+-+Sampige+Road,+beside+joyalukkas,+2nd+main+road,+Sampige+Rd,+Malleshwara,+Bengaluru,+Karnataka+560003/@12.9947466,77.5715698,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bae3d0cc715c5f1:0x3d248ed06c907856!2m2!1d77.5715698!2d12.9947466?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Pacific Mall",
    address:
      "Shop no SH/1F/06, Pacific-Delhi, Najafgarh Road, Khayala, Delhi-110018",
    phone: "+91 8660699931",
    storeId: "67992486050",
    gmapLink:
      "https://www.google.com/maps/dir//Pacific+Mall+Tagore+Garden,+Najafgarh+Rd,+Tagore+Garden,+Tilak+Nagar,+New+Delhi,+Delhi+110018/@28.6426474,77.1042716,17z/data=!3m1!5s0x390d0363c39289ad:0x5a90c705824ccbc0!4m8!4m7!1m0!1m5!1m1!1s0x390d0363c4edf747:0x240c75aa3d09de7a!2m2!1d77.106379!2d28.642372",
  },
  {
    name: "GIVA - R City Mall",
    address:
      "Survey no.146-b, C.T.S. No. 166, 166/1 to 23 LAL BAHADUR SHASTRI MARG, GHATKOPAR WEST, MUMBAI 400086",
    phone: "+91 8217587642",
    storeId: "67976396962",
    gmapLink:
      "https://www.google.com/maps/dir//S-15,+2nd+Floor,+GIVA+-+R+City+Mall,+R+City+Mall,+Lal+Bahadur+Shastri+Rd,+Amrut+Nagar,+Ghatkopar+West,+Mumbai,+Maharashtra+400086/@19.0993558,72.9163421,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3be7c7c42155ec4b:0x20232908c1bcd6d2!2m2!1d72.9163421!2d19.0993558?hl=en-GB",
  },
  {
    name: "GIVA - Phoenix Palladium",
    address:
      "The Phoenix Mills Limited, Phoenix Mills Compound, 462, Senapati Bapat Marg, Lower Parel, Mumbai – 400 013",
    phone: "+91 9076359407",
    storeId: "67923280034",
    gmapLink:
      "https://www.google.com/maps/dir//Unit+%23T14B,+3rd+Floor,+Block+No.2,+GIVA+-+Phoenix+Palladium,+East+Zone,+Phoenix+Palladium,+462,+Senapati+Bapat+Marg,+Lower+Parel,+Mumbai,+Maharashtra+400013/@18.9940532,72.8241298,15z/data=!3m1!5s0x3be7ce8c7a97e06d:0xbbf7fd84abd813ca!4m8!4m7!1m0!1m5!1m1!1s0x3be7cf585c7cf099:0xf30516c36652ba30!2m2!1d72.8241298!2d18.9940532?hl=en-GB",
  },
  {
    name: "GIVA - Sarath City",
    address:
      "\n      Sarath City Mall, A.Survey No. 38, 39P, 40, 41, 42, 48, 49, 50, 51, 52 &amp; 53 situated at Kothaguda Village,\n      Serilingampally Mandal, R. R. District, Hyderabad, Telangana 500084\n    ",
    phone: "+91 9701469106",
    storeId: "67933569186",
    gmapLink:
      "https://www.google.com/maps/dir//UG-115,+GIVA+-+Sarath+City,+Upper+Ground,+Sarath+City+Capital+Mall,+Gachibowli+-+Miyapur+Rd,+Whitefields,+HITEC+City,+Kondapur,+Telangana+500084/@17.457948,78.3636007,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bcb93749e701025:0x7231938470d9f2fb!2m2!1d78.3636007!2d17.457948?hl=en-GB",
  },
  {
    name: "GIVA - Lajpat Nagar",
    address: "C-15 LAJPAT NAGAR II, LAJPAT NAGAR, DELHI 110024",
    phone: "+91 8310183603",
    storeId: "67985834146",
    gmapLink:
      "https://www.google.com/maps/dir//Ground+Floor,+GIVA+-+Lajpat+Nagar,+C-15,+Block+C,+Lajpat+Nagar+II,+Lajpat+Nagar,+New+Delhi,+Delhi+110024/@28.5709003,77.2395811,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x390ce3749314b3cf:0x804211b626283350!2m2!1d77.2395811!2d28.5709003?hl=en-GB",
  },
  {
    name: "GIVA - Kamla Nagar",
    address: "UA 38 Bungalow Road Jawahar Nagar, Kamala Nagar Delhi 110007",
    phone: "+91 8310190645",
    storeId: "67962667170",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Jewellery,+GIVA+Jewellery-+Trends,+39,+Bungalow+Rd,+Kamla+Nagar,+Delhi,+110007/@28.6805255,77.2081544,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x390cfd6aa87b949d:0xdea6ca9aa61c4756!2m2!1d77.2048303!2d28.6837235?hl=en-GB",
  },
  {
    name: "GIVA - VR Mall",
    address:
      "G-47B,Koyembedu Village, Egmore-Nungambakkam Taluk, Chennai, Tamil Nadu- 600040",
    phone: "+91 8310183573",
    storeId: "67994419362",
    gmapLink:
      "https://www.google.com/maps/dir//VR+Chennai,+100+Feet+Rd,+Thirumangalam,+Anna+Nagar,+Chennai,+Tamil+Nadu+600040/@13.0805465,80.1926259,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3a526402be882bef:0xad2f3f45016d6710!2m2!1d80.197132!2d13.0805465",
  },
  {
    name: "GIVA - Venice Mall",
    address:
      "The Grand Venice, Plot No- SH3, Site IV, Near Pari Chowk, Greater Noida, Uttar Pradesh - 201308.",
    phone: "+91 8310190638",
    storeId: "67961290914",
    gmapLink:
      "https://www.google.com/maps/dir//Plot+No+SH3,+GIVA+-+The+Grand+Venice+Mall,+Site+IV,+LG-8G,+Ground+Floor,+The+Grand+Venice+Mall,+near+Pari+Chowk,+Greater+Noida,+Uttar+Pradesh+201308/@28.4533329,77.5253796,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x390cc1ea9d1b23e7:0x27459aa4d25c436!2m2!1d77.5253796!2d28.4533329?hl=en-GB",
  },
  {
    name: "GIVA - Indiranagar",
    address:
      "Corporation no. 1132 Ground floor, 100ft road,Indiranagar, HAL 2nd stage, Bengaluru 560038",
    phone: "+91 8310183385",
    storeId: "67979018402",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+%231%2F1,+GIVA+-+Indiranagar,+1132,+100+Feet+Rd,+HAL+2nd+Stage,+Indiranagar,+Bengaluru,+Karnataka+560038/@12.96958,77.6422258,19z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bae173f4a1fd809:0xa85ec6161cef97b2!2m2!1d77.6415177!2d12.96958?hl=en-GB",
  },
  {
    name: "GIVA - Nexus Shantiniketan Mall",
    address:
      "Whitefield Main Rd, Thigalarapalya, Krishnarajapura, Bengaluru, Karnataka 560067",
    phone: "+91 9380647600",
    storeId: "66245132450",
    gmapLink:
      "https://www.google.com/maps/dir//Nexus+Shantiniketan+Mall,+Whitefield+Main+Rd,+Thigalarapalya,+Krishnarajapura,+Bengaluru,+Karnataka+560067/@12.989536,77.7259128,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bae11eea0053a71:0x81f6e5e82b75da88!2m2!1d77.7281015!2d12.989536?hl=en-GB",
  },
  {
    name: "GIVA - Mantri Square Mall",
    address:
      "Mantri square Mall, First Floor, Sampige Rd, Malleswaram, Bengaluru, Karnataka 560003",
    phone: "+91 7019206024",
    storeId: "66245165218",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Mantri+Square+Mall,+Mantri+square+Mall,+First+Floor,+Sampige+Rd,+Malleswaram,+Bengaluru,+Karnataka+560003/@12.9914061,77.568802,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bae17980c259595:0xdc90334b5831791f!2m2!1d77.5709907!2d12.9914061?hl=en-GB",
  },
  {
    name: "GIVA - Vega City Mall",
    address:
      "1st Floor, Vega City Mall, Dollar Layout, BTM 2nd Stage, BTM Layout, Bengaluru, Karnataka 560076",
    phone: "+91 8981265096",
    storeId: "66499379362",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Vega+City+Mall,+1st+Floor,+Vega+City+Mall,+Dollar+Layout,+BTM+2nd+Stage,+BTM+Layout,+Bengaluru,+Karnataka+560076/@12.9076762,77.6012309,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bae156daf466205:0x333d229d5002f6b!2m2!1d77.6012309!2d12.9076762?hl=en-GB",
  },
  {
    name: "GIVA Jayanagar",
    address:
      "383, 72, Ground Floor, 11th Main Rd, Jayanagar 3rd Block, Bengaluru, Karnataka 560011",
    phone: "+91 9066271334",
    storeId: "66829910178",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Jayanagar,+383,+72,+Ground+Floor,+11th+Main+Rd,+Jayanagar+3rd+Block,+Bengaluru,+Karnataka+560011/@12.8860043,77.5242018,13z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bae1578df7f57fb:0x7e45ef4df135db5a!2m2!1d77.5859541!2d12.9314031?hl=en-GB",
  },
  {
    name: "GIVA - Koramangala",
    address:
      "Money Center, Shop No.6, Salarpuria, 121, opp. Nexus Koramangala Mall, 7th Block, Bengaluru, Karnataka 560095",
    phone: "+91 9019923633",
    storeId: "67055583394",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Koramangala,+Money+Center,+Shop+No.6,+Salarpuria,+121,+opp.+Nexus+Koramangala+Mall,+7th+Block,+Bengaluru,+Karnataka+560095/@12.8860043,77.5242018,13z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bae159650872eef:0x6c70f75487024797!2m2!1d77.6125928!2d12.9346625?hl=en-GB",
  },
  {
    name: "GIVA - Ambience Mall",
    address:
      "\n      Ambience Mall 2, Shop No. G-18, Ground Floor, Nelson Mandela Marg, Ambience Island, Vasant Kunj II, Vasant Kunj,\n      New Delhi, Delhi 110070\n    ",
    phone: "+91 6360317919",
    storeId: "67055648930",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Ambience+Mall,+Vasant+Kunj,+Ambience+Mall+2,+Shop+No.+G-18,+Ground+Floor,+Nelson+Mandela+Marg,+Ambience+Island,+Vasant+Kunj+II,+Vasant+Kunj,+New+Delhi,+Delhi+110070/@28.5412473,77.1551671,15z/data=!3m1!5s0x390d1dce982775f1:0xd177578919cde739!4m8!4m7!1m0!1m5!1m1!1s0x390d1dcd41a76f09:0x1826f64b1ec85f0c!2m2!1d77.1551671!2d28.5412473?hl=en-GB",
  },
  {
    name: "GIVA - Galleria Mall",
    address:
      "1st Floor, RMZ Galleria Mall, Ambedkar Colony, Yelahanka, Bengaluru, Karnataka 560064",
    phone: "+91 9945142047",
    storeId: "67055812770",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Galleria+Mall,+1st+Floor,+RMZ+Galleria+Mall,+Ambedkar+Colony,+Yelahanka,+Bengaluru,+Karnataka+560064/@13.0940679,77.594819,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bae1906815d2835:0x2e14336364a2df4f!2m2!1d77.594819!2d13.0940679?hl=en-GB",
  },
  {
    name: "GIVA - Mercado HS",
    address:
      "Shop No: 02, Mercado, Opp Municipal Market, Chimanlal Girdharlal Rd, Ahmedabad, Gujarat 380006",
    phone: "+91 6361527674",
    storeId: "68003496098",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA,+Shop+No:+02,+GIVA+-+Ahmedabad+-+Mercado,+GIVA+Mercado,+Chimanlal+Girdharlal+Rd,+opposite+Municipal+Market,+Vasant+Vihar,+Navrangpura,+Ahmedabad,+Gujarat+380006/@23.0349341,72.5604891,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x395e8508fc60609b:0xffdc5249bc656a04!2m2!1d72.5604891!2d23.0349341!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Ambedkar Road HS",
    address: "44/A, AMBEDKAR ROAD, GHAZIABAD, Ghaziabad, Uttar Pradesh 201001",
    phone: "+91 8310183531",
    storeId: "68026826914",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA,+GIVA+-+Ghaziabad+-+Ambedkar+Road,+44%2FA,+Ambedkar+Rd,+next+to+reliance+jewels,+New+Gandhi+Nagar,+Bagh+Bhathyari,+Naya+Ganj,+Ghaziabad,+Uttar+Pradesh+201001/@28.6570377,77.4345329,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390cf1eeaa01e2d1:0xaf6426ad413125e8!2m2!1d77.4345329!2d28.6570377!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Kanpur PPN HS",
    address: "PPN MARKET SHOP NO. 3 NEAR PARED CHAURAHA",
    phone: "+91 8660699929",
    storeId: "68026433698",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA,+Shop+no:3,+GIVA+-+Kanpur+-+PPN+Market,+near+Pared,+P.P.N+Market,+Permat,+Chauraha,+Kanpur,+Uttar+Pradesh+208001/@26.4745309,80.3439313,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x399c39851767a92b:0x437f809714cd3dc5!2m2!1d80.3439313!2d26.4745309!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Sodepur HS",
    address: "GIVA 24 Barasat Road,Ward no.17,holding sodepur,kolkata-700110",
    phone: "+91 6361527620",
    storeId: "68037410978",
    gmapLink:
      "https://www.google.com/maps/dir//Ward+no:17,+GIVA+-+Kolkata+-+Sodepur,+GIVA,+24,+Barasat+Rd,+next+to+Bandhan+bank,+Burmah+Shell+Colony,+Sodepur,+Kolkata,+West+Bengal+700110/@22.6985778,88.3869795,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x39f89dd8468413c5:0x986547d559e73672!2m2!1d88.3869795!2d22.6985778!3e0?entry=ttu",
  },
  {
    name: "GIVA - Wakad HS",
    address:
      "Shop No 5, Ground Floor, Giva Store, Building B, beside Starbucks, Taluka, Wakad, Mulashi, Maharashtra 411057",
    phone: "+91 6361527626",
    storeId: "68099932322",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+No+5,+Ground+Floor,+GIVA+-+Pune+-+Wakad+High+street,+Giva+Store,+Building-B,+beside+Starbucks,+Taluka,+Wakad,+Mulashi,+Maharashtra+411057/@18.6066111,73.7522403,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bc2b913afa03431:0xe2939923c426f659!2m2!1d73.7522403!2d18.6066111!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Phoenix Mall of the Millenium",
    address:
      "\n      Giva, G-4, Ground floor, Phoenix Mall of Millennium, Shankar Kalat Nagar, Wakad, Pune, Pimpri-Chinchwad,\n      Maharashtra 411057\n    ",
    phone: "+91 9113990435",
    storeId: "67992453282",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+G-4,+Ground+floor,+GIVA+-+Pune+-+Phoenix+Mall+of+Millennium,+Phoenix+Mall+of+Millennium,+Shankar+Kalat+Nagar,+Wakad,+Pune,+Pimpri-Chinchwad,+Maharashtra+411057/@18.6007228,73.7567692,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bc2b9bedc8381e7:0xc73c6320e1c51213!2m2!1d73.7567692!2d18.6007228!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Seasons Mall",
    address:
      "Giva, Unit G 4B, Season’s Mall, Magarpatta City, Hadapsar, Pune, Maharashtra 411013",
    phone: "+91 9019923624",
    storeId: "68083843234",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+Unit+G+4B,+GIVA+-+Pune+-+Seasons+Mall,+Seasons+Mall,+Magarpatta,+Hadapsar,+Pune,+Maharashtra+411013/@18.5118932,73.9238347,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bc2bf0028c4bcc1:0x3ede3640bf0b0890!2m2!1d73.9238347!2d18.5118932!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Karishma Society HS",
    address:
      "\n      Shop 01/02, Kothrud NS No.16, Stuti Mahati Gokul Apts, Kothibhiskar Project, opposite Karishma society, Pune,\n      Maharashtra 411038\n    ",
    phone: "+91 6360134291",
    storeId: "68076535970",
    gmapLink:
      "https://www.google.com/maps/dir//NS+No.16,+GIVA+-+Pune+-+Karishma+Society,+Stuti+Mahati+Gokul+Apts,+Kothibhiskar+Project,+Shop+01%2F02,+opposite+Karishma+society,+Kothrud,+Pune,+Maharashtra+411038/@18.5124938,73.8081305,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bc2bf6badbc2507:0xccfaafc6d52f7ae2!2m2!1d73.8081305!2d18.5124938!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Aerohub Mall",
    address:
      "\n      Giva, No. E014 , Ground Floor, Aerohub, West Block, Meenambakkam, near Chennai International Airport, Chennai,\n      Tamil Nadu 600027\n    ",
    phone: "+91 9380732718",
    storeId: "68096458914",
    gmapLink:
      "https://www.google.com/maps/place/GIVA+-+Chennai+-+Aerohub/@12.9815893,80.1655084,15z/data=!4m6!3m5!1s0x3a525f6924cd5edd:0x9008ef274d9e8db3!8m2!3d12.9815893!4d80.1655084!16s%2Fg%2F11vlpys136?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Swaroop Nagar HS",
    address:
      "Giva,7/120 B-A Shop No.2,Ground Floor,Swaroop Nagar,Kanpur, Uttar Pradesh - 208002",
    phone: "+91 9565667799",
    storeId: "68064706722",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+No.+2+Ground+Floor,+GIVA+-+Kanpur+-+Swaroop+Nagar,+Giva,+7%2F120+B-A,+Swaroop+Nagar,+Kanpur,+Uttar+Pradesh+208002/@26.4831907,80.3190266,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x399c39fd8e0d6e31:0x9068a80c675b009e!2m2!1d80.3190266!2d26.4831907!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - JM Road Pune HS",
    address:
      "\n      GIVA, Ground Floor, 1279, Jangali Maharaj Rd, near C/O Prakash Lodge, Shivaji Nagar, Deccan Gymkhana, Pune,\n      Maharashtra 411005\n    ",
    phone: "+91 8310119220",
    storeId: "68088103074",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA,+Ground+Floor,+GIVA+-+Pune+-+J+M+Road,+1279,+Jangali+Maharaj+Rd,+near+C%2FO+Prakash+Lodge,+Shivaji+Nagar,+Deccan+Gymkhana,+Pune,+Maharashtra+411005/@18.5183862,73.8448239,15z/data=!3m1!5s0x3bc2c07834bddfcd:0xe0cf51578752ff2!4m9!4m8!1m0!1m5!1m1!1s0x3bc2c166dcb806c5:0xc8596dc076e50305!2m2!1d73.8448239!2d18.5183862!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Kalkaji HS",
    address:
      "Giva, H-11 (A) Kalkaji Main Road, near Mc Donalds Kalkaji, Delhi, 110019",
    phone: "+91 8310183461",
    storeId: "68094623906",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+H,+GIVA+-+Delhi+-+Kalkaji,+11+(A,+Kalkaji+Main+Rd,+near+Mc+Donalds,+Kalkaji+Extension,+Kalkaji,+Delhi,+New+Delhi,+Delhi+110019/@28.5411823,77.2561745,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390ce3e3e4d09b9f:0xd05ea9d20c8109b2!2m2!1d77.2561745!2d28.5411823!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Mall of India Noida",
    address:
      "\n      GIVA- Shop no.- F378E- 2nd floor, DLF Mall of India Noida Sector 18, Gautambuddha Nagar, Uttar Pradesh - 201301\n    ",
    phone: "+91 6360134369",
    storeId: "67357376674",
    gmapLink:
      "https://www.google.com/maps/dir//2nd+Floor+Shop+No,+GIVA+-+Noida+-+Mall+of+India,+Dlf+Mall+Of+India,+378E,+Sector+18,+Noida,+Uttar+Pradesh+201301/@28.5670716,77.321134,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390ce5e3706433e7:0xcd0f7b25544c9264!2m2!1d77.321134!2d28.5670716!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI0MTAxMy4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - V3S Mall Delhi",
    address:
      "\n      # G122A, Ground Floor, V3S Mall, Vikas Marg, Laxmi Nagar Commercial Complex, Swasthya Vihar, New Delhi, Delhi\n      110092\n    ",
    phone: "+91 8660699945",
    storeId: "68003528866",
    gmapLink:
      "https://www.google.com/maps/dir//G122A,+Ground+Floor,+GIVA+-+Delhi+-+V3S+Mall,+V3S+Mall,+Vikas+Marg,+Laxmi+Nagar+Commercial+Complex,+Swasthya+Vihar,+New+Delhi,+Delhi,+110092/@28.637357,77.2864174,15z/data=!3m1!5s0x390d1d2539164093:0xeec7716c1a643762!4m8!4m7!1m0!1m5!1m1!1s0x390cfd075494a1db:0x4b94cccb1a5101ca!2m2!1d77.2864174!2d28.637357?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Karol Bagh HS",
    address:
      "6/54, Ajmal Khan Rd, Block 5, WEA, Karol Bagh, New Delhi, Delhi 110005",
    phone: "+91 8660699927",
    storeId: "68014375074",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Delhi+-+Karol+Bagh,+6%2F54,+Ajmal+Khan+Rd,+Block+5,+WEA,+Karol+Bagh,+New+Delhi,+Delhi,+110005/@28.647191,77.190068,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x390d036fbc9167d3:0xb704283ea46f1a04!2m2!1d77.190068!2d28.647191?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Nirman Vihar",
    address:
      "Giva E- 357, BLOCK C , BHARTI ARTIST COLONY , PREET VIHAR , DELHI - 110092",
    phone: "+91 8310190452",
    storeId: "68003594402",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA,+No:5,+GIVA+-+Delhi+-+Nirman+Vihar,+near+Metro+pillar+72,+Block+C,+Bharati+Artist+Colony,+Preet+Vihar,+New+Delhi,+Delhi,+110092/@28.6376813,77.2897365,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x390cfbc545bc65db:0xf1a16a43e4019ed7!2m2!1d77.2897365!2d28.6376813?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Punjagutta Mall",
    address:
      "Unit No L2-12, B7, Nagarjuna Hills, Punjagutta, Hyderabad, Telangana 500082",
    phone: "+91 8660699932",
    storeId: "67978657954",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Hyderabad+-+Next+Galleria+Mall,+Panjagutta,+Next+Galleria+Mall,+L2-12,+Punjagutta+Rd,+Irram+Manzil+Colony,+Punjagutta,+Hyderabad,+Telangana+500082/@17.4291123,78.4500345,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bcb910113baaf9b:0x7b40c8fa033b659d!2m2!1d78.4500345!2d17.4291123?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Dilsukhnagar HS",
    address:
      "\n      Metro pillar no A1562, Rajanigandha Complex, Bus Stop, No 18/97/5, Apartments, opposite Chaitanyapuri Main Road,\n      Janpriya Sauda Complex, Kamala Nagar, Dilsukhnagar, Hyderabad, Telangana 500060\n    ",
    phone: "+91 8660699935",
    storeId: "68003004578",
    gmapLink:
      "https://www.google.com/maps/dir//Metro+pillar+no+A1562,+GIVA+-+Hyderabad+-+Dilsukhnagar,+Rajanigandha+Complex,+Bus+Stop,+GIVA+store+,+No+18%2F97%2F5,+Apartments,+opposite+Chaitanyapuri+Main+Road,+Janpriya+Sauda+Complex,+Kamala+Nagar,+Dilsukhnagar,+Hyderabad,+Telangana+500060/@17.3678624,78.5325436,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bcb990e82a5cbe5:0x8d8f911e00e11ff4!2m2!1d78.5324672!2d17.3680797?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Hazratganj HS",
    address:
      "G2, UGF 1 Shahnajaf Rd, opposite Sahara Ganj Mall, Hazratganj, Lucknow, Uttar Pradesh 226001",
    phone: "+91 9019612860",
    storeId: "68025647266",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+G2,+UGF,+GIVA+-+Lucknow+-+Hazratganj,+1,+Shahnajaf+Rd,+opposite+Sahara+Ganj+Mall,+Prem+Nagar,+Hazaratganj,+Lucknow,+Uttar+Pradesh+226001/@26.855442,80.9449211,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x399bfdf6921aaa71:0x262ac1d0d389d1a5!2m2!1d80.9449211!2d26.855442?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Airia Mall",
    address:
      "AIRIA MALL, Unit No. GF 45, Ground, Sector 68, Gurugram, Haryana 122101",
    phone: "+91 9019923617",
    storeId: "67372253346",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Airia+Mall,+AIRIA+MALL,+Unit+No.+GF+45,+Ground,+Sector+68,+Gurugram,+Haryana+122101/@28.3827216,77.0524963,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x390d2352ba0162a7:0xab1f58de2cf7bb8!2m2!1d77.052508!2d28.382692?hl=en-GB",
  },
  {
    name: "GIVA - Sector 14 Gurgaon HS",
    address:
      "Shop no - 2385, Anamika enclave, Opp Dhingra motors, old Delhi Gurgaon road, Gurgaon, Haryana 122001",
    phone: "+91 6360097411",
    storeId: "68013588642",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+no+-+2385,+GIVA+-+Gurgaon+-+Sector+14,+Anamika+Enclave,+Old+Delhi+Gurgaon+Rd,+opp.+Dhingra+motors,+Anamika+Enclave,+Sector+14,+Gurugram,+Haryana+122001/@28.4693788,77.0388187,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x390d19e87ba2dbbf:0x55905605a7e24cb7!2m2!1d77.0388187!2d28.4693788?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Vegas Mall",
    address:
      "2nd Floor, Vegas Mall Plot No. 6, North, Pocket 1, Sector 14 Dwarka, Dwarka, Delhi, 110075",
    phone: "+91 9019923606",
    storeId: "67513516194",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Vegas+Mall,+2nd+Floor,+Vegas+Mall+Plot+No.+6,+North,+Pocket+1,+Sector+14+Dwarka,+Dwarka,+Delhi,+110075/@28.6015023,77.0296966,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x390d1b0251319e53:0x78687f86bc8ded33!2m2!1d77.0296966!2d28.6015023?hl=en-GB",
  },
  {
    name: "GIVA - Bhartiya City",
    address:
      "\n      Unit No. 14 (b) - F, First Floor, Bhartiya Mall of Bengaluru Bhartiya City, Thanisandra Main Rd, Devin Paradise\n      Enclave, Bengaluru, Karnataka 560064\n    ",
    phone: "+91 9539919148",
    storeId: "67513680034",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA,+Unit+No.+14+(b)+-+F,+First+Floor,+Bhartiya+Mall+of+Bengaluru+Bhartiya+City,+Thanisandra+Main+Rd,+Devin+Paradise+Enclave,+Bengaluru,+Karnataka+560064/@13.0834448,77.6437715,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bae197871887783:0x8a0513266358ca4d!2m2!1d77.6437805!2d13.0834553?hl=en-GB",
  },
  {
    name: "GIVA - Nexus Seawoods Mall",
    address:
      "Unit FF-62,Plot No R, 1, Seawoods Station Rd, Navi Mumbai, Maharashtra 400706",
    phone: "+91 8976123000",
    storeId: "67652911266",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Nexus+Seawoods+Mall,+Nexus+Seawoods+Mall,+Railway+Station,+FF-62,+1st+Floor,+near+Seawoods,+Sector+40,+Nerul,+Navi+Mumbai,+Maharashtra+400706/@19.021551,73.017811,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3be7c3cfef29ef31:0x948a31c534bb2722!2m2!1d73.017811!2d19.021551?hl=en-GB",
  },
  {
    name: "GIVA - Mall of Jaipur",
    address:
      "FF 105, 1st Floor, Mall of Jaipur, Gandhi Path W, B Block, Vaishali Nagar, Jaipur, Rajasthan 302021",
    phone: "+91 6360134178",
    storeId: "67918921890",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Mall+of+Jaipur,+FF+105,+1st+Floor,+Mall+of+Jaipur,+Gandhi+Path+W,+B+Block,+Vaishali+Nagar,+Jaipur,+Rajasthan+302021/@26.9060757,75.7342181,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x396db500a9249ff7:0x908505680d3b34cc!2m2!1d75.7342181!2d26.906076?hl=en-GB",
  },
  {
    name: "GIVA - Marina Mall",
    address: "G-13, Ground Floor Marina Mall, Egattur, Tamil Nadu 603103",
    phone: "+91 9751993552",
    storeId: "67564568738",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Marina+Mall,+G-13,+Ground+Floor+Marina+Mall,+Egattur,+Tamil+Nadu+603103/@12.8360623,80.2295172,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3a525b4ae70505b3:0x1922a5b2740e6130!2m2!1d80.2295172!2d12.8360623?hl=en-GB",
  },
  {
    name: "GIVA - Nexus Westend",
    address:
      "\n      Westend Mall, GFN-8B, Ground Floor North, Nexus, Mahadji Shinde Rd, near Parihar Chowk, Harmony Society, Ward No.\n      8, Wireless Colony, Aundh, Pune, Maharashtra 411007\n    ",
    phone: "+91 7775072161",
    storeId: "67652976802",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Nexus+Westend,+Westend+Mall,+GFN-8B,+Ground+Floor+North,+Nexus,+Mahadji+Shinde+Rd,+near+Parihar+Chowk,+Harmony+Society,+Ward+No.+8,+Wireless+Colony,+Aundh,+Pune,+Maharashtra+411007/@18.5611289,73.8071478,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bc2bf60ad6f7235:0x8b561fd5e799e0b2!2m2!1d73.8071478!2d18.5611289?hl=en-GB",
  },
  {
    name: "GIVA - Orion Mall",
    address:
      "Bride Shop No. 4, 1st Floor, Orion Mall, Dr Rajkumar Rd, Rajajinagar, Bengaluru, Karnataka 560055",
    phone: "+91 8217296672",
    storeId: "67923247266",
    gmapLink:
      "https://www.google.com/maps/dir//Bride+Shop+No.+4,+1st+Floor,+GIVA+-+Orion+Mall,+Orion+Mall,+Dr+Rajkumar+Rd,+Rajajinagar,+Bengaluru,+Karnataka+560055/@13.0110208,77.5549561,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bae3d7cdb6563e1:0xb31ce3df5564b1af!2m2!1d77.5549561!2d13.0110208?hl=en-GB",
  },
  {
    name: "GIVA - Phoenix Marketcity",
    address:
      "\n      1st, : PHOENIX MARKETCITY, F-09, Lal Bahadur Shastri Rd, Patelwadi.Kurla, Kamani, Kurla West, Mumbai, Maharashtra\n      400070\n    ",
    phone: "+91 8879165510",
    storeId: "67652878498",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Phoenix+Marketcity,+Mumbai,+1st,+:+PHOENIX+MARKETCITY,+F-09,+Lal+Bahadur+Shastri+Rd,+Patelwadi.Kurla,+Kamani,+Kurla+West,+Mumbai,+Maharashtra+400070/@19.0867132,72.8900123,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3be7c97a0e2a9ceb:0xa72f72794914bcf4!2m2!1d72.8900123!2d19.0867132?hl=en-GB",
  },
  {
    name: "GIVA - Lulu Bengaluru",
    address:
      "G-34 , No 19/2, Part of CTS No2, Mysore Deviation Road, Gopalapura (Ward No 96), Bengaluru - 560023",
    phone: "+91 8310662728",
    storeId: "67918987426",
    gmapLink:
      "https://www.google.com/maps/dir//Lulu+Hypermarket+Bengaluru,+near+Sujatha+Theatre,+Okalipuram,+Rajajinagar,+Bengaluru,+Karnataka+560023/@12.8859973,77.4891809,12z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae17cbb8276a8b:0xacfdd8a4a4ced9fd!2m2!1d77.5631212!2d12.9812479!3e0",
  },
  {
    name: "GIVA - Commercial Street",
    address:
      "Maruthi Commercial Complex, Upper Ground Floor (First Floor), No 30 Commercial Street, Bengaluru-560001",
    phone: "+91 8217588968",
    storeId: "67953623202",
    gmapLink:
      "https://www.google.com/maps/dir//12.9820042,77.6088943/@12.9820042,77.6067056,17z/data=!4m2!4m1!3e0?hl=en",
  },
  {
    name: "GIVA - Vijay Nagar",
    address:
      "Mahendra Towers ,No 72, Shop No GF 2,East of Chord Road Vijaynagar- 560040.",
    phone: "+91 7483031363",
    storeId: "67933634722",
    gmapLink:
      "https://www.google.com/maps/dir/28.59008,77.3783552/giva+vijaynagar/@20.4578107,67.6419972,5z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x3bae3da7b5f6248f:0x7853e5a0cf2c57da!2m2!1d77.5371798!2d12.9693666?entry=ttu",
  },
  {
    name: "GIVA - Nexus Koramangla",
    address:
      "Ground floor,The Nexus Mall, Hosur Rd, Chikku Lakshmaiah Layout, Koramangala, Bengaluru, Karnataka 560095",
    phone: "+91 9379609576",
    storeId: "67961225378",
    gmapLink:
      "https://www.google.com/maps/dir//KGR+-+15,+Ground+Floor,+GIVA+-+Nexus+Koramangala,+Nexus+Koramangala,+Hosur+Rd,+Chikku+Lakshmaiah+Layout,+Koramangala,+Bengaluru,+Karnataka+560095/@12.9345937,77.6114331,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae1539ed600ecf:0x29c2dabc6ebe7e0a!2m2!1d77.6114331!2d12.9345937!3e0",
  },
  {
    name: "GIVA - Phoenix Marketcity, Chennai",
    address:
      "S-10, 2nd Floor, Phoenix Market City, 142, Velachery Rd, Velachery, Chennai, Tamil Nadu 600042",
    phone: "+91 9884788227",
    storeId: "67513581730",
    gmapLink:
      "https://www.google.com/maps/dir//S-10,+2nd+Floor,+GIVA+-+Phoenix+Marketcity+Chennai,+Phoenix+Market+City,+142,+Velachery+Rd,+Velachery,+Chennai,+Tamil+Nadu+600042/@12.9913026,80.2166199,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3a52674063873c8b:0x3e77f056c5c3bacc!2m2!1d80.2166199!2d12.9913026?hl=en-GB",
  },
  {
    name: "GIVA - Marathalli Bangalore",
    address:
      "Sy no 97/2B, Marathalli Main road, Subbaiah Reddy road, opposite MGA Hospital, Bangalore - 560037",
    phone: "+91 8310190477",
    storeId: "67933601954",
    gmapLink:
      "https://www.google.com/maps/dir//97%2F2,+Ground+Floor,+GIVA+-+Bangalore+-+Marathahalli,+Marathahalli+Main+Rd,+opp.+MGA+Hospital,+Subbaiah+Reddy+Colony,+Aswath+Nagar,+Marathahalli,+Bengaluru,+Karnataka+560037/@12.9571683,77.700093,15z/data=!3m1!5s0x3bae1232e73ad2fd:0x2cec2a154a1022bc!4m9!4m8!1m0!1m5!1m1!1s0x3bae13da0d3d9e1f:0xe0ad853ea627a385!2m2!1d77.700093!2d12.9571683!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Gold Souk Mall",
    address:
      "\n      Shop No - GF-02, Gold Souk, Mall, Vyapar Kendra Rd, Sec-43, Block C, Sushant Lok Phase I, Kanahi, Gurugram,\n      Haryana 122002\n    ",
    phone: "+91 9036061694",
    storeId: "68692213922",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Gurgaon+-+Gold+Souk+Mall/@28.4507006,77.0787096,17z/data=!3m1!4b1!4m6!3m5!1s0x390d19bf95a81391:0x9770ed758111b6e6!8m2!3d28.4507006!4d77.0787096!16s%2Fg%2F11vq_nznc8?entry=ttu",
  },
  {
    name: "GIVA - Shyamal Unicus HS",
    address:
      "Shop #2, Shyamal Cross Rd, Balgayatri Society Part-2, Satellite, Shyamal, Ahmedabad, Gujarat 380015",
    phone: "+91 6360307074",
    storeId: "68076470434",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Ahmedabad+-+Shyamal+Unicus/@23.0143401,72.5309171,17z/data=!3m1!4b1!4m6!3m5!1s0x395e856990c883bf:0x4fbec7ba6e4dfe4a!8m2!3d23.0143401!4d72.5309171!16s%2Fg%2F11vsyzp8qx?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Maninagar HS",
    address:
      "\n      GIVA, Shop No. gf-04, Stellar 2, opp. Bhairavnath Brts Bus Stand, Nirankar Society, Rambagh, Maninagar, Ahmedabad,\n      Gujarat 380008\n    ",
    phone: "+91 7483031365",
    storeId: "68046782626",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Ahmedabad+-+Maninagar/@22.9957689,72.5984967,15z/data=!4m6!3m5!1s0x395e8510b6c46bd7:0xed51803cf8b2591!8m2!3d22.9957689!4d72.5984967!16s%2Fg%2F11vsyzr5qf?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Nexus Vijaya",
    address:
      "GF, Nexus, Giva, Vijaya Mall, 183, Arcot Rd, opp. to Lifestyle, Vadapalani, Chennai, Tamil Nadu 600026",
    phone: "+91 9606977624",
    storeId: "68670980258",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Chennai+-+Nexus+Vijaya+Mall/@13.0504769,80.2105409,15z/data=!4m6!3m5!1s0x3a526744c92f9651:0xd8f7361770fbd7c5!8m2!3d13.0504769!4d80.2105409!16s%2Fg%2F11ldh4_865?entry=ttu",
  },
  {
    name: "GIVA - Nexus Sujana",
    address:
      "\n      GIVA - Hyderabad - Nexus Sujana Mall, The Forum Sujana Mall, K P H B Phase 6, Kukatpally, Hyderabad, Telangana\n    ",
    phone: "+91 9606977622",
    storeId: "68616683682",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Hyderabad+-+Nexus+Sujana+Mall/@17.4860837,78.3883082,17z/data=!3m1!4b1!4m6!3m5!1s0x3bcb91e8b7281ce3:0xcafcdca98a5bb1d0!8m2!3d17.4860837!4d78.3883082!16s%2Fg%2F11ldr0jd33?entry=ttu",
  },
  {
    name: "GIVA - South Ex HS",
    address:
      "\n      GIva, G5, Ground Floor, Gate no 2, near Metro Station South Extension, South Extension I, Block G, New Delhi,\n      Delhi, 110049\n    ",
    phone: "+91 9606977621",
    storeId: "68323868834",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Delhi+-+South+Ex/@28.5690328,77.2200004,15z/data=!4m6!3m5!1s0x390ce347a35560c5:0x8464b55a7487d0c2!8m2!3d28.5690328!4d77.2200004!16s%2Fg%2F11vph1kq8y?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Spectrum Mall",
    address:
      "GIVA shop no. 2c, 2d Ground floor, Spectrum mall, Gardenia Gateway, Sector 75, Noida, Uttar Pradesh 201301",
    phone: "+91 8660699930",
    storeId: "68224385186",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Noida+-+Spectrum+Mall/@28.5727556,77.3789334,15z/data=!4m6!3m5!1s0x390cefd38602b555:0xe55b62533a5f453!8m2!3d28.5727556!4d77.3789334!16s%2Fg%2F11vpz0m1x5?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Karkhana HS",
    address:
      "\n      GIVA, Plot No 28, Survey no 60,61, 62/1, Karkhana Rd, opposite McDonald's, DAD Quarters, New Vasavi Nagar,\n      Tirumalagiri, Secunderabad, Telangana 500015\n    ",
    phone: "+91 7483029208",
    storeId: "68272750754",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Hyderabad+-+Karkhana/@17.4648753,78.5039022,15z/data=!4m6!3m5!1s0x3bcb9bd34da647c3:0xaf0b548b10953119!8m2!3d17.4648753!4d78.5039022!16s%2Fg%2F11ld3sfpjh?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Somajiguda HS",
    address:
      '\n      C/G1/G2, Amit Plaza, Giva, "6, 885-7, Raj Bhavan Rd, beside Ather Showroom, Somajiguda, Hyderabad, Telangana\n      500082\n    ',
    phone: "+91 9113853929",
    storeId: "68227268770",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Hyderabad+-+Somajiguda/@17.4283636,78.455701,15z/data=!4m6!3m5!1s0x3bcb91d09507ea95:0x3890080e939e1084!8m2!3d17.4283636!4d78.455701!16s%2Fg%2F11vs39fz2c?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Shahdara HS",
    address:
      "\n      GIVA, Upper GF, A5, Main market, Main 100 Feet Rd, beside Tata Croma, Block C, North Chhajupur, Shahdara, Delhi,\n      110094\n    ",
    phone: "+91 9606977618",
    storeId: "68230414498",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Delhi+-+Shahdara/@28.6895633,77.2865381,15z/data=!4m6!3m5!1s0x390cfbfc9519be81:0x8a79067d19028bf2!8m2!3d28.6896316!4d77.2865479!16s%2Fg%2F11lcl_0vp4?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - HSR HS",
    address:
      "\n      114 &amp; 115, 80 Feet Main Road &amp; 27th Main Road, HSR, 2nd Sector, Sector 2, HSR Layout, Bengaluru, Karnataka 560102\n    ",
    phone: "+91 6360098051",
    storeId: "68997054626",
    gmapLink:
      "https://www.google.com/maps/dir//114+%26+115,+Giva+-+Bangalore+-+HSR+Layout,+80+Feet,+27th+Main+Rd,+near+Stack+route,+Parangi+Palaya,+Sector+2,+HSR+Layout,+Bengaluru,+Karnataka+560104/@12.9106382,77.6516635,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae154fd3e79d93:0xf227d453bcb2e495!2m2!1d77.6516635!2d12.9106382!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Brigade Road HS",
    address:
      "GIVA, Shop No. 54/1 No. 54, Brigade Road, Next to Selec Hypermart",
    phone: "+91 9606977620",
    storeId: "68460642466",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA,+Shop+No.+54%2F1,+Giva+-+Bangalore+-+Brigade+Road,+54,+Brigade+Rd,+next+to+Selec+Hypermart,+Shanthala+Nagar,+Ashok+Nagar,+Bengaluru,+Karnataka+560001/@12.972852,77.6075,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae178e08e78b23:0xc119e94d2d6d5e48!2m2!1d77.6075!2d12.972852!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Rohini HS",
    address: "12,ground floor,pocket E-1,Sector-7,Rohini, Delhi - 110085",
    phone: "+91 8310190669",
    storeId: "68161732770",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA,+12+Ground+floor,+Pocket,+GIVA+-+Delhi+-+Rohini,+E-1,+beside+Caratlane,+Pocket+2,+Sector+7,+Rohini,+Delhi,+110085/@28.7025165,77.1164541,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390d035ae4294581:0x966fb53c60e49d69!2m2!1d77.1164541!2d28.7025165!3e0?entry=ttu",
  },
  {
    name: "GIVA - Paschim Vihar HS",
    address:
      "\n      Giva Jewellery, Block A-3/6, Gurudwara Road, 110063, near Shop No-2, A 3 Block, Paschim Vihar, New Delhi, Delhi,\n      110063\n    ",
    phone: "+91 9113990471",
    storeId: "68099965090",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Delhi+-+Paschim+Vihar,+Giva+Jewellery,+Block+A-3%2F6,+Gurudwara+Road,+110063,+near+Shop+No-2,+A+3+Block,+Paschim+Vihar,+New+Delhi,+Delhi,+110063/@28.6696521,77.1051607,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390d0350e4b724cf:0x3cf9692ccb2cd96a!2m2!1d77.1051607!2d28.6696521!3e0?entry=ttu",
  },
  {
    name: "GIVA - Sector 15 Faridabad HS",
    address:
      "\n      Ground Floor, Giva jewellery, near Chayoos, SCF NO:-41, Main Market Rd, Urban Estate, Sector 15, Faridabad,\n      Haryana 121007\n    ",
    phone: "+91 9019600726",
    storeId: "68273143970",
    gmapLink:
      "https://www.google.com/maps/dir///@28.3963281,77.319542,15z/data=!4m2!4m1!3e0?entry=ttu",
  },
  {
    name: "GIVA - Metropolitan Mall HS",
    address:
      "Shop No- 3, Ground Floor, MGF METROPOLITAN DLF CITY PHASE 2 Gurgaon",
    phone: "+91 9633452604",
    storeId: "68773478562",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+No-+3,+Ground+Floor,+GIVA+-+Gurgaon+-+MGF+Metropolitan+Mall,+MGF+METROPOLITAN,+Mushedpur,+DLF+Phase+2,+Sector+25,+Gurugram,+Shahpur,+Haryana+122022/@28.4876667,77.0881034,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390d19361ec01073:0xd70cf3c0d7ebc1c5!2m2!1d77.0881034!2d28.4876667!3e0?entry=ttu",
  },
  {
    name: "GIVA - Himayath Nagar HS",
    address:
      "367/368/369, Street Number 1, Gagan Mahal, Domalguda, Himayatnagar, Hyderabad, Telangana 500029",
    phone: "+91 6361527572",
    storeId: "68049043618",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+367%2F368,+GIVA+-+Hyderabad+-+Himayatnagar,+369,+Street+Number+1,+opp.+Dadu's,+Gagan+Mahal,+Domalguda,+Himayatnagar,+Hyderabad,+Telangana+500029/@17.406388,78.479489,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bcb997c67a6a225:0xcacd76a0d873cf53!2m2!1d78.4792581!2d17.4060709!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Kukatpally HS",
    address:
      "\n      Plot no:1058&amp;1059, MRCB Building, MIG 41, Dharmareddy colony,, Adjacent to Zudio, KPHB Phase1,Kukatpally,\n      Hyderabad, Telangana 500074\n    ",
    phone: "+91 9606977629",
    storeId: "68460675234",
    gmapLink:
      "https://www.google.com/maps/dir//Phase+1,+GIVA+-+Hyderabad+-+Kukatpally,+MRCB+Building,+Dharma+Reddy+Colony+Phase+II,+Dharma+Reddy+Colony+Phase+I,+Kukatpally,+Hyderabad,+Telangana+500085/@17.4972214,78.3856184,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bcb916be6f740cd:0x10ac61c87a80cd25!2m2!1d78.385614!2d17.497222!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - AS Rao Hyderabad HS",
    address:
      "\n      House No. 1-18-13/11 on plot bearing No. 11,UNION BANK BUILDING{SAINIKPURI BRANCH} ,DR. A S RAO NAGAR MAIN ROAD,\n      Electronics corporation Employees co-operative house Construction society limited, Kapra circle and Kapra\n      Mandal,500062.\n    ",
    phone: "+91 9606977649",
    storeId: "68475224226",
    gmapLink:
      "https://www.google.com/maps/dir//11+on+plot+bearing+No.+11,+Giva+-+Hyderabad+-+AS+Rao+Nagar,+Union+Bank+Building,+House+No.+1-18-13,+A.+S.+Rao+Nagar,+Hyderabad,+Telangana+500062/@17.4803141,78.5563302,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bcb9b4cc1b77c05:0xe8300a2b6c754375!2m2!1d78.5563302!2d17.4803141!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - MG Road Indore HS",
    address:
      "\n      Giva, Ground floor, Labh Ganga, Mahatma Gandhi Rd, 11 Bungalow Colony, New Palasia, Indore, Madhya Pradesh 452001\n    ",
    phone: "+91 8310171509",
    storeId: "68058480802",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+Ground+floor,+GIVA+-+Indore+-+MG+Road,+Labh+Ganga,+Mahatma+Gandhi+Rd,+11+Bungalow+Colony,+New+Palasia,+Indore,+Madhya+Pradesh+452001/@22.7238233,75.8673169,14z/data=!3m1!5s0x3962fd38ac9da735:0xe0fdab19428715b1!4m9!4m8!1m0!1m5!1m1!1s0x3962fd9752d2b9df:0xea288fa21cd6a5fb!2m2!1d75.8824195!2d22.7233349!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - MI Road HS",
    address:
      "shop no. 66, Barvadiya bhavan, GIVA, House no. J, 42-2, Mirza Ismail Rd, Jaipur, Rajasthan 302001",
    phone: "+91 6361310778",
    storeId: "68071719074",
    gmapLink:
      "https://www.google.com/maps/dir//shop+no.+66,+GIVA+-+Jaipur+-+M.I.+Road,+Barvadiya+bhavan,+GIVA,+House+no.+J,+42-2,+Mirza+Ismail+Rd,+Jaipur,+Rajasthan+302001/@26.9165207,75.8121862,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x396db73e8cfac909:0xc9d84d2de770834e!2m2!1d75.812103!2d26.9164872!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Vaishali Nagar HS",
    address:
      "\n      Giva, G3-G4, GF, Vaishali Tower II, Nursery Circle, B Block, Vaishali Nagar, beside Vision express, Jaipur,\n      Rajasthan 302021\n    ",
    phone: "+91 9019923625",
    storeId: "68094591138",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+G3-G4,+GF,+GIVA+-+Jaipur+-+Vaishali+Nagar,+Vaishali+Tower+II,+Nursery+Cir,+beside+Vision+express,+Acharya+Vinoba+Bhave+Nagar,+B+Block,+Vaishali+Nagar,+Jaipur,+Rajasthan+302021/@26.910912,75.7382563,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x396db5fc7eaf1a01:0x379f94322dbd4ae!2m2!1d75.7382563!2d26.910912!3e0?entry=ttu",
  },
  {
    name: "GIVA - Bhawanipur HS",
    address: "GIVA, 7, Elgin Road, Sreepally, Bhowanipore, Kolkata",
    phone: "+91 8310190626",
    storeId: "68014702754",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+GIVA+-+Kolkata+-+Elgin+Road,+7,+Elgin+Rd,+next+to+Imagine+store,+Sreepally,+Bhowanipore,+Kolkata,+West+Bengal+700020/@22.5377814,88.3525941,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3a0277d69e5028c7:0x6432e97ce9e78b45!2m2!1d88.3525941!2d22.5377814!3e0?entry=ttu",
  },
  {
    name: "GIVA - URS Mysore HS",
    address: "#29, D Devaraj Urs Road Mysore 570001",
    phone: "+91 9380647600",
    storeId: "68444324002",
    gmapLink:
      "https://www.google.com/maps/dir//Giva+-+Mysore+-+URS+Road,+29,+D+Devaraj+Urs+Rd,+Subbarayanakere,+Shivarampet,+Mysuru,+Karnataka+570001/@12.3093014,76.6495539,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3baf710eafbc943b:0x313767f9709cd1e9!2m2!1d76.6495539!2d12.3093014!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Chinchwad Pune HS",
    address:
      "\n      Giva, G-4, Ground floor, Phoenix Mall of Millennium, Shankar Kalat Nagar, Wakad, Pune, Pimpri-Chinchwad,\n      Maharashtra 411057, India\n    ",
    phone: "+91 9036061692",
    storeId: "68706959522",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+G-4,+Ground+floor,+GIVA+-+Pune+-+Phoenix+Mall+of+Millennium,+Phoenix+Mall+of+Millennium,+Shankar+Kalat+Nagar,+Wakad,+Pune,+Pimpri-Chinchwad,+Maharashtra+411057/@18.6007228,73.7567692,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bc2b9bedc8381e7:0xc73c6320e1c51213!2m2!1d73.7567692!2d18.6007228!3e0?entry=ttu",
  },
  {
    name: "GIVA - Satara Road HS",
    address:
      "\n      Giva store , Kamal Heritage Ashmega Nagar, Pune - Satara road, Padmadarshan Society, Sant nagar, Parvati Paytha,\n      Pune, Maharashtra 411009\n    ",
    phone: "+91 9606977645",
    storeId: "68766171298",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+-+Pune+-+Satara+Road,+Giva+store,+Kamal+Heritage,+Ashmega+Nagar,+Satara+Rd,+Vasant+Baug,+Padmadarshan+Society,+Sant+Nagar,+Parvati+Paytha,+Pune,+Maharashtra+411009/@18.4787359,73.8571636,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bc2ebba69032a83:0xf2e29881a33067d0!2m2!1d73.8571636!2d18.4787359!3e0?entry=ttu",
  },
  {
    name: "GIVA - Viman Nagar HS",
    address:
      "Unit no. F-52A, Survey Number 207, Viman Nagar Road, Pune- 411014",
    phone: "+91 9113854772",
    storeId: "68224352418",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+1,+Giva+-+Pune+-+Viman+Nagar,+Giva+Store,+Alfa+Primiyo,+opp.+Khalsa+Dairy,+beside+of+Lenskart+%26+Toothsi,+Mhada+Colony,+Viman+Nagar,+Pune,+Maharashtra+411014/@18.5679146,73.9143432,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bc2c105dabb34e5:0xd835d9ff5678f704!2m2!1d73.9143432!2d18.5679146!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Kharadi Pune HS",
    address:
      "Paradip Plaza,East Wing,Building V,Ganga Platino,Shop no 2,Ground floor",
    phone: "+91 9606977635",
    storeId: "68526768290",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+no+2,+Ground+floor,+Giva+-+Pune+-+Kharadi,+Vascon+Forest+County+Building-V,+GANGA+PLATINO,+Paradip+Plaza,+East+Wing,+Kharadi,+Pune,+Maharashtra+411014/@18.5553197,73.9497954,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bc2c331e55f067b:0x156dcad2e4083e00!2m2!1d73.9497954!2d18.5553197!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - MG Road Vijaywada HS",
    address:
      "\n      GIVA, 40-6, 31, MG Rd, opp. Lifestyle, Revenue Colony Park, Sidhartha Nagar, Labbipet, Vijayawada, Andhra Pradesh\n      520010, India\n    ",
    phone: "+91 9606977623",
    storeId: "68483186850",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA,+40-6,+GIVA+-+Vijayawada+-+MG+Road,+31,+MG+Rd,+opp.+Lifestyle,+Revenue+Colony+Park,+Sidhartha+Nagar,+Labbipet,+Vijayawada,+Andhra+Pradesh+520010/@16.5007465,80.6462583,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3a35fbf61304075f:0x76c472d9269948ab!2m2!1d80.6462583!2d16.5007465!3e0?hl=en-GB&entry=ttu",
  },
  {
    name: "GIVA - Koramangla 2 HS",
    address:
      "\n      Giva, GF, #649 Art Arcade, 100 Feet Rd, 6th Block, Koramangala, Sony Centre signal, Bangalore, Karnataka 560095\n    ",
    phone: "+91 9686161041",
    storeId: "68088135842",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+GF,+%23649,+GIVA+Jewellery+%7C+Koramangala+2+%7C+Silver,+Gold,+Lab+Grown+Diamonds,+Art+Arcade,+Sony+Centre+signal,+100+Feet+Rd,+6th+Block,+Koramangala,+Bengaluru,+Karnataka+560095/@12.9372523,77.6266267,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae15f70de3ecf3:0xdbc95e5d22bc77ba!2m2!1d77.6266267!2d12.9372523!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI0MTAxMy4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Express Avenue",
    address:
      "Giva showroom Express avenue Chennai No 237 , 2nd floor Next to Zivame showroom Royapettah Chennai 600014",
    phone: "+91 9606977634",
    storeId: "68037542050",
    gmapLink:
      "https://www.google.com/maps/dir//Giva+-+Chennai+-+Express+Avenue+Mall,+Express+Avenue+Mall,+Whites+Rd,+Express+Estate,+Royapettah,+Chennai,+Tamil+Nadu+600002/@13.0589175,80.2645268,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3a52670011780b0f:0xb8550ef59ec1965c!2m2!1d80.2645271!2d13.0589113!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI0MTAxMy4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Kharghar HS",
    address:
      "Shree krishna paradise shop no-3, near prime mall, sector 12, Kharghar, Mumbai, Maharastra, 410210",
    phone: "+91 9606977616",
    storeId: "68803035298",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+No+-03,+Giva+-+Mumbai+-+Kharghar,+Shree+Krishna+Paradise,+Near,+Prime+Mall+Ln,+Sector+12,+Kharghar,+Mumbai,+Navi+Mumbai,+Maharashtra+410210/@19.0415862,73.0639891,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3be7c300361fa111:0x413b01f20013403d!2m2!1d73.0640482!2d19.0414014!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI0MTAxMy4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - FC Road HS",
    address:
      "Fergusson chambers shop no 3&amp;4 CL Appts plot no 1216/6/1 Fergusson College Road Shivajinagar Pune 411004",
    phone: "+91 6360098426",
    storeId: "69154111650",
    gmapLink:
      "https://www.google.com/maps/dir//shop+no+3%264,+GIVA+Jewellery+%7C+FC+Road+%7C+Silver,+Gold,+Lab+Grown+Diamonds,+CL+Appts+plot,+Fergusson+chambers,+1216%2F6%2F1,+Fergusson+College+Rd,+Shivajinagar,+Pune,+Maharashtra+411004/@18.5215695,73.841194,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bc2bfca6fca3533:0x468b784e632681af!2m2!1d73.8411573!2d18.521568!3e0?entry=ttu&g_ep=EgoyMDI0MTAxMy4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Barasat HS",
    address: "GIVA 24 Barasat Road,Ward no.17,holding sodepur,kolkata-700110",
    phone: "+91 9019923632",
    storeId: "68272259234",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA-BARASAT-KOLKATA,+Barasat,+Kolkata,+West+Bengal+700124/@22.7113042,88.4757291,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x39f8990070b8ef8d:0x92bade0b0bd9befb!2m2!1d88.4757291!2d22.7113042!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Patrakarpuram HS",
    address:
      "GIVA, 3/17, Anand plaza, Patrakar Puram, Vivek Khand 2, Gomti Nagar, Lucknow, Uttar Pradesh 226010, India",
    phone: "+91 9606977646",
    storeId: "68692050082",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA,+3%2F17,+GIVA+Silver+%26+Gold+Jewellery+%7C+Patrakarpuram+%7C+Lab+Grown+Diamonds,+Anand+plaza,+Patrakar+Puram,+Vivek+Khand+2,+Gomti+Nagar,+Lucknow,+Uttar+Pradesh+226010/@26.8528193,81.0011688,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x399be31605b0318f:0x9881855f6ed57d22!2m2!1d81.0011545!2d26.8526594!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Experio Mall",
    address: "Experio mall shop no -007 Vibhuti khand lucknow",
    phone: "+91 9606977650",
    storeId: "68460708002",
    gmapLink:
      "https://www.google.com/maps/dir//Giva,+Shop+No.+007,+GIVA+Silver+%26+Gold+Jewellery+%7C+Experio+Mall+%7C+Lab+Grown+Diamonds,+Experio+Mall,+near+Indira+Gandhi+Pratisthan,+Vibhuti+Khand,+Gomti+Nagar,+Lucknow,+Uttar+Pradesh+226010/@26.8682863,81.0118324,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x399be384c281feed:0xf7b53e0b25af5986!2m2!1d81.0118324!2d26.8682863!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Sector 18 NOIDA HS",
    address:
      "DLF Mall of India, 2nd Floor, Shop No. 378E, Sector-18, Noida, Uttar Pradesh 201301",
    phone: "+91 9606977632",
    storeId: "68641783970",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Noida+-+Sector+18+%7C+Lab+Grown+Diamonds,+Plot+No-+J-12+Block,+Maharaja+Agrasen+Marg,+J+Block,+Pocket+J,+Sector+18,+Noida,+Uttar+Pradesh+201301/@28.5686137,77.3243789,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390ce5ca3e1a4d95:0x83ce8cc8a41881a9!2m2!1d77.3243789!2d28.5686137!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Madhyamgram HS",
    address:
      "Giva Madhyamgram, Sodepur Road, East Bijoy Nagar gate no 1. Kolkata - 700129",
    phone: "+91 8310190496",
    storeId: "68058448034",
    gmapLink:
      "https://www.google.com/maps/dir//gate+no+1,+GIVA+Silver+%26+Gold+Jewellery+%7C+Madhyamgram+%7C+Lab+Grown+Diamonds,+Giva+Madhyamgram,+Sodepur+Rd,+Bijoynagar,+East,+Kolkata,+West+Bengal+700129/@22.6931282,88.4624057,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x39f89fa26f113305:0xbc9eaae2e5499ca2!2m2!1d88.4624057!2d22.6931282!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Laxmi Road 2 Pune HS",
    address:
      "\n      Giva Store, Shop no. 8/ 9/ 375, Dulhan Complex, Laxmi Chambers, Laxmi Road, Narayan Peth, Pune 411030, Pune,\n      Maharashtra.\n    ",
    phone: "+91 9606975326",
    storeId: "68676681890",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+No+-08,+GIVA+Silver+%26+Gold+Jewellery+%7C+Laxmi+Road+Pune+%7C+Lab+Grown+Diamonds,+Dulhan+Complex,+375,+Laxmi+Rd,+near+Shagun+Chowk,+Narayan+Peth,+Pune,+Maharashtra+411030/@18.5143926,73.849607,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bc2c19fb1cd1083:0xdb0f58cd77150f1c!2m2!1d73.8496932!2d18.5142047!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - PVR ANUPAM",
    address:
      "Giva-Shop No-4,DDA shopping complex (pvr anupam) Saket,New delhi-110017",
    phone: "+91 9148186210",
    storeId: "68956782754",
    gmapLink:
      "https://www.google.com/maps/dir//Giva-Shop+No-4,+GIVA+Silver+%26+Gold+Jewellery+%7C+PVR+Anupam+Saket+%7C+Lab+Grown+Diamonds,+DDA+Shopping+Complex,+Pramod+Mahajan+Marg,+Ashok+Vihar,+Saket,+New+Delhi,+Delhi+110017/@28.5231194,77.2070273,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390ce1fd298a8813:0x3a9ee9ce88f76468!2m2!1d77.2070273!2d28.5231194!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - GOOD EARTH MALL",
    address:
      "Unit no - 14, Ground Floor, Good Earth City Centre, Sector 50, Gurugram, Haryana 122018",
    phone: "+91 9148186211",
    storeId: "69154209954",
    gmapLink:
      "https://www.google.com/maps/dir//Unit+no+-+14,+Ground+Floor,+GIVA+Silver+%26+Gold+Jewellery+%7C+Good+Earth+Mall+%7C+Lab+Grown+Diamonds,+Good+Earth+City+Centre,+Pocket+H,+Nirvana,+Sector+50,+Gurugram,+Fatehpur,+Haryana+122018/@28.4215108,77.0535418,15z/data=!3m1!5s0x390d2281136e8c07:0x369b464cb2340f95!4m9!4m8!1m0!1m5!1m1!1s0x390d231b09060775:0xab625ecf21224426!2m2!1d77.053403!2d28.4218851!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Omaxe Chowk HS",
    address:
      "Unit No-125, Ground Floor, Omaxe Chowk, Chandini Chowk, H.C.Sen Marg, Gandhi Maidan, Delhi- 110006",
    phone: "+91 9148186215",
    storeId: "68049305762",
    gmapLink:
      "https://www.google.com/maps/dir//Unit+No-125,+Ground+Floor,+GIVA+Silver+%26+Gold+Jewellery+%7C+Omaxe+Chowk+%7C+Lab+Grown+Diamonds,+Omaxe+Chowk,+HC+Sen+Marg,+Kaccha+Bagh+Area,+Chandni+Chowk,+Delhi,+110006/@28.6578146,77.2312143,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390cfdb626087c1f:0x66433a3b0413c45!2m2!1d77.2312143!2d28.6578146!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Chinar Park HS",
    address:
      "9, Block, B315 Napara Chinar Park Bidhannagar Kolkata, West Bengal- 700067",
    phone: "+91 9148186214",
    storeId: "68866408610",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Chinar+Park+%7C+Lab+Grown+Diamonds,+BLOCK-B,+9,+315,+Chinar+Park,+Atghara,+Bidhan+nagar,+Napara,+Kolkata,+West+Bengal+700157/@22.6232893,88.4422218,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x39f89f52a0b191cb:0xe99e17e2848b217b!2m2!1d88.4423676!2d22.623411!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Shivranjini HS",
    address:
      "Silicon Valley, 17-18, Satellite Rd, Suryapooja Block B, Satellite, Ahmedabad, Gujarat 380015",
    phone: "+91 9148186212",
    storeId: "69273190562",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Shivranjani+%7C+Lab+Grown+Diamonds,+Silicon+Valley,+17-18,+Shivranjani+Cross+Rd,+Suryapooja+Block+B,+Satellite,+Ahmedabad,+Gujarat+380015/@23.0250638,72.5300585,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x395e8571a3eede39:0x92990b7ed7bf8399!2m2!1d72.5300585!2d23.0250638!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Park Street HS",
    address: "Mezzanine Floor, Queensmansions, 12D, Parkstreet",
    phone: "+91 9113983262",
    storeId: "68323836066",
    gmapLink:
      "https://www.google.com/maps/dir//Mezzanine+Floor,+GIVA+Silver+%26+Gold+Jewellery+%7C+Park+Street+%7C+Lab+Grown+Diamonds,+Queens+Mansion,+12D,+Park+St,+Park+Street+area,+Kolkata,+West+Bengal+700071/@22.5534386,88.3517645,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3a0277abee07b7db:0x88068b0f0516942c!2m2!1d88.3517645!2d22.5534386!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - MAHAGUN MALL",
    address:
      "Shop No. 32 Ground Floor Mahagun metro Mall Sector -3 Vaishali Ghaziabad UP. 201010",
    phone: "+91 9113993762",
    storeId: "69341544610",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+No.+32+Ground+Floor,+GIVA+Silver+%26+Gold+Jewellery+%7C+Mahagun+Mall+%7C+Lab+Grown+Diamonds,+Mahagun+metro+Mall,+Sector+3F,+Sector+3,+Vaishali,+Ghaziabad,+Uttar+Pradesh+201010/@28.6447708,77.3353783,15z/data=!3m1!5s0x390cfad775a7a5fd:0x2d82dfdc6e6a3613!4m9!4m8!1m0!1m5!1m1!1s0x390cfbe93e46d069:0xa3dd95ad01224049!2m2!1d77.3353783!2d28.6447708!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - JP NAGAR HS",
    address: "No.249, situated at 24TH MAIN ROAD, 5TH PHASE BANGALORE- 560078",
    phone: "+91 9148186217",
    storeId: "69321982114",
    gmapLink:
      "https://www.google.com/maps/dir//Ground+Floor,+GIVA+Silver+%26+Gold+Jewellery+%7C+JP+Nagar+%7C+Lab+Grown+Diamonds,+Nanjudeshwara+plaza,+249,+24th+Main+Rd,+opposite+Nandini+hotel,+5th+Phase,+KR+Layout,+JP+Nagar+Phase+6,+J.+P.+Nagar,+Bengaluru,+Karnataka+560078/@12.9005917,77.5857653,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae1500322c0f4b:0xbf840a59a15757e8!2m2!1d77.5858484!2d12.9054565!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Mall Of Dehradun",
    address: "Mall of Dehradun, Haridwar Road, Dehradun-248005",
    phone: "+91 9148186204",
    storeId: "68049141922",
    gmapLink:
      "https://www.google.com/maps/dir//Lower+Ground+Floor,+GIVA+Silver+%26+Gold+Jewellery+%7C+Mall+Of+Dehradun+%7C+Lab+Grown+Diamonds,+Mall+of+Dehradun,+IIP,+Mohkampur,+Mohkam+Pur+Khurd,+Dehradun,+Uttarakhand+248005/@30.2666146,78.0825083,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390929f0a6000847:0xddaad40909a55792!2m2!1d78.0825083!2d30.2666146!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - LP Sawani HS",
    address:
      "\n      GIVA Shop no. 1 Universal Trade Centre, LP Savani, Road, in front of Indian Oil, Adajan, Surat, Gujarat 395009\n    ",
    phone: "+91 9148186205",
    storeId: "68069818530",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Shop+no.+1,+GIVA+Silver+%26+Gold+Jewellery+%7C+LP+Sawani+%7C+Lab+Grown+Diamonds,+Universal+Trade+Centre,+LP+Savani+Cir,+in+front+of+Indian+Oil,+Adajan+Gam,+Adajan,+Surat,+Gujarat+395009/@21.1989786,72.7837364,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3be04d002bea999d:0x427f40a4de3b4ab3!2m2!1d72.7837008!2d21.1989495!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Gandhi Nagar HS",
    address:
      "\n      Ground Floor, Survey No. 148, Pramukh Avenue, No. 11 &amp; 12, Sargasan Cross Road, Near Jade Blue, Gandhinagar,\n      Gujarat- 382421\n    ",
    phone: "+91 9148186213",
    storeId: "69218697378",
    gmapLink:
      "https://www.google.com/maps/dir//Ground+Floor,+Survey+No.+148,+GIVA+Silver+%26+Gold+Jewellery+%7C+Gandhinagar+%7C+Lab+Grown+Diamonds,+Pramukh+Avenue,+11+%26+12,+Sargasan+Cross+Rd,+near+Jade+Blue,+Kudasan,+Gandhinagar,+Gujarat+382421/@23.1846156,72.62434,19z/data=!4m9!4m8!1m0!1m5!1m1!1s0x395c2b567f9af439:0x250aef1ca167498f!2m2!1d72.6239519!2d23.1848145!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Kompally HS",
    address:
      "D.No. 1-076/1/A/NR, N Narayanapet, Basheerbad, Kompally, Hyderabad, Secunderabad, Telangana 500067",
    phone: "+91 7019629419",
    storeId: "69662015650",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Kompally+%7C+Lab+Grown+Diamonds,+NR+N+Narayanapet,+D.No.+1-076%2F1%2FA,+Basheerbad,+Kompally,+Secunderabad,+Telangana+500067/@17.5214878,78.4830155,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bcb8527a8858fcf:0x685b4348707a0a7!2m2!1d78.4830155!2d17.5214878!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - LT Road Mumbai HS",
    address:
      "Shop no. 04 &amp; 05 (Amalgamated) , Ground floor, Sheela Apt, Off LT Road, Borivali West, Mumbai 400092",
    phone: "+91 8310124847",
    storeId: "68046356642",
    gmapLink:
      "https://www.google.com/maps/dir//Giva+Jewellery,+GIVA+Silver+%26+Gold+Jewellery+%7C+Borivali+LT+Road+%7C+Lab+Grown+Diamonds,+Sheela+Society,+4+%26+5,+Gulmohar+Rd,+Sundar+Nagar,+Borivali+West,+Mumbai,+Maharashtra+400092/@19.2300605,72.8536856,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3be7b19fd44fd8b5:0x6f76e5233162c68a!2m2!1d72.8536856!2d19.2300605!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Valasaravakkam HS",
    address: "9, Arcot Road, Valasaravakkam, Chennai-600087",
    phone: "+91 9148150381",
    storeId: "69961351330",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Valasaravakkam+%7C+Lab+Grown+Diamonds,+9,+Arcot+Rd,+Janaki+Nagar,+Alwartirunagar,+Valasaravakkam,+Chennai,+Tamil+Nadu+600087/@13.0420697,80.1767195,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3a52610c1ebefe2d:0xdfd3f34313dc40e2!2m2!1d80.1767195!2d13.0420697!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - PANVEL HS",
    address:
      "Shop No. 9&amp;10, JK Plaza, MTNL Rd, near Shivaji Statue, Old Panvel, Panvel, Navi Mumbai, Maharashtra 410206",
    phone: "+91 9148186209",
    storeId: "69321949346",
    gmapLink:
      "https://www.google.com/maps/dir//Shop,+09,+GIVA+Silver+%26+Gold+Jewellery+%7C+Panvel+%7C+Lab+Grown+Diamonds,+JK+Plaza,+10,+MTNL+Rd,+near+Chhatrapati+Shivaji+Maharaj+Chowk,+Old+Panvel,+Panvel,+Navi+Mumbai,+Maharashtra+410206/@18.9866818,73.1123242,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3be7e9d08cd4c083:0xaa21c59e762b165d!2m2!1d73.1123242!2d18.9866818!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - South Bopal",
    address:
      "\n      No.2 TCB, The Corner Block, Gala Gymkhana Road, Opp. City center, Chittavan, South Bopal, Ahmedabad, Gujarat\n      380058\n    ",
    phone: "+91 9108962611",
    storeId: "69896634530",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+South+Bopal+%7C+Lab+Grown+Diamonds,+The+Corner+Block,+Gala+Gymkhana+Rd,+opp.+City+center,+Chittavan,+South+Bopal,+Bopal,+Ahmedabad,+Gujarat+380058/@23.0235332,72.4713559,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x395e9bd25e8b8917:0x856718e57adead7d!2m2!1d72.4713559!2d23.0235332!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Sector 17 Vashi HS",
    address:
      "Shop No. 4&amp;5, Om Rachna, Plot No.3 Sector 17, Vashi, Navi Mumbai 400703 Maharashtra",
    phone: "+91 9108962610",
    storeId: "69589303458",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+No.+4%265,+GIVA+Silver+%26+Gold+Jewellery+%7C+Sector+17+Vashi+%7C+Lab+Grown+Diamonds,+Om+Rachna,+Plot+No.3,+Liberty+Housing+Society,+Sector+17,+Vashi,+Navi+Mumbai,+Maharashtra+400703/@19.0705337,72.9978934,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3be7c1eea8e64d89:0xf30a5aa719ed8ad0!2m2!1d72.9976826!2d19.0705989!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - AIPL JOY STREET",
    address:
      "AIPL Joy Street Unit no. GF 118, 119,Sector 66U, Gurugram - 122002 Haryana",
    phone: "+91 9108962608",
    storeId: "70239092898",
    gmapLink:
      "https://www.google.com/maps/dir//Unit+no.+GF+118,+GIVA+Silver+%26+Gold+Jewellery+%7C+AIPL+Joy+Street+%7C+Lab+Grown+Diamonds,+AIPL+JOY+STREET,+119,+Sector+66U,+Badshahpur,+Sector+66,+Gurugram,+Haryana+122002/@28.3920227,77.059573,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390d23965f561b5b:0x39726d13c89f5779!2m2!1d77.059573!2d28.3920227!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Sindhu Bhawan HS",
    address:
      "Shop no 7 Ground Floor, Silver Radiance, Sindhu Bhawan Marg, Bodakdev, Ahmedabad, Gujarat 380059",
    phone: "+91 9108433250",
    storeId: "69860753570",
    gmapLink:
      "https://www.google.com/maps/dir//Ground+Floor,+GIVA+Silver+%26+Gold+Jewellery+%7C+Sindhu+Bhavan+%7C+Lab+Grown+Diamonds,+Silver+Radiance,+Sindhu+Bhavan+Marg,+Bodakdev,+Ahmedabad,+Gujarat+380059/@23.0387602,72.5107926,15z/data=!3m1!5s0x395e9b444500e01d:0x5dbd2abf7889f0d6!4m9!4m8!1m0!1m5!1m1!1s0x395e9b7cd884432b:0x775c69ef16580fe7!2m2!1d72.5107926!2d23.0387602!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Blue Sapphire Mall",
    address:
      "\n      Unit G-30A &amp; 4A Galaxy blue sapphire plaza, plot no- c-03, sector 4, Greater Noida West, Gautam Buddha Nagar,\n      Uttar Pradesh 201309\n    ",
    phone: "+91 9108962609",
    storeId: "69806915746",
    gmapLink:
      "https://www.google.com/maps/dir//Plot+No-+C,+GIVA+Silver+%26+Gold+Jewellery+%7C+Blue+Sapphire+Mall+%7C+Lab+Grown+Diamonds,+Galaxy+blue+sapphire+plaza,+Unit+G-30A+%26+4A,+03,+Sector+4,+Greater+Noida,+Uttar+Pradesh+201309/@28.6105576,77.4314286,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390cef41e94e6b49:0x6cbaae8b5c5ecf98!2m2!1d77.4356249!2d28.6072504!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - 3B2 Mohali",
    address: "3B2, Sector 60, S.A.S. Nagar, Mohali, Punjab- 160059 India",
    phone: "+91 8217578745",
    storeId: "70229524642",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Mohali+%7C+Lab+Grown+Diamonds,+3B2,+Phase+3B-1,+Sector+60,+Sahibzada+Ajit+Singh+Nagar,+Punjab+160059/@30.7122545,76.7189261,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390fef6097cd2821:0xae11042ec8ae4f4e!2m2!1d76.7189261!2d30.7122545!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Pheonix Palladium AMD",
    address:
      "\n      Unit No. T48 Third Floor, Pheonix Palladium Mall, Sarkhej Gandhinagar Highway, Thaltej, Ahmedabad- 380054 Gujarat\n    ",
    phone: "+91 8217579742",
    storeId: "70098583714",
    gmapLink:
      "https://www.google.com/maps/dir//Unit+No.+T48+Third+Floor,+GIVA+Silver+%26+Gold+Jewellery+%7C+Phoenix+Palladium+%7C+Lab+Grown+Diamonds,+Pheonix+Palladium+Mall,+Sarkhej+-+Gandhinagar+Hwy,+Thaltej,+Ahmedabad,+Gujarat+380054/@23.0581699,72.5212607,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x395e83bc86a81311:0xbbed0c597b59bee7!2m2!1d72.5212607!2d23.0581699!3e0?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - ELANTE CHANDIGARH",
    address:
      "Unit No. 135A First Floor, Nexus Elante, Plot No 178-178A, Industrial Area, Phase I, Chandigarh- 160002",
    phone: "+91 9035053665",
    storeId: "70229557410",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Elante+Mall+%7C+Lab+Grown+Diamonds,+First+Floor,+Elante+Mall,+Ginger+Hotel+Road,+Purv+Marg,+Industrial+Area+Phase+I,+Chandigarh,+160002/@30.7048587,76.802179,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390d17003202e63f:0xe4191fe21739651d!2m2!1d76.802974!2d30.7049607!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Rohini F&amp;B Mall",
    address:
      "Shop 27A &amp; 27B D-Mall Rohini Sector 10 Rohini New Delhi 110085",
    phone: "+91 9108433246",
    storeId: "69682888866",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+27A+%26+27B,+GIVA+Silver+%26+Gold+Jewellery+%7C+Rohini+F%26B+Mall+%7C+Lab+Grown+Diamonds,+D-Mall,+Swarn+Jayanti+Park,+Sector+10,+Rohini,+New+Delhi,+Delhi,+110085/@28.7166923,77.1135955,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390d01693eedbec7:0x97f85b0c9fbbc872!2m2!1d77.1135955!2d28.7166923!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - SILVER ARC MALL",
    address:
      "GF 06, Silver Arc Mall, Ferozpur Road, New Aarti Chowk, Gurdev Nagar, Ludhiana- 141001 Punjab",
    phone: "+91 8618037098",
    storeId: "70239420578",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+No+6,+Ground+Floor,+GIVA+Silver+%26+Gold+Jewellery+%7C+Silver+Arc+Mall+%7C+Lab+Grown+Diamonds,+Silver+Arc+Mall,+New,+Ferozepur+Rd,+Near+Aarti+Chowk,+Gurdev+Nagar,+Ludhiana,+Punjab+141001/@30.9001083,75.8295275,15z/data=!3m1!5s0x391a83c7ec381905:0x63c528b9a4403498!4m9!4m8!1m0!1m5!1m1!1s0x391a834aaeebff4f:0xd1c03f08c7d42c9!2m2!1d75.8295275!2d30.9001083!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - ATTAPUR HS",
    address:
      "Shop No. 1&amp;2, H. No. 4-3-144/2,Pilar no 122, Somireddy Nagar, Attapur, Hyderabad, Telangana- 500048",
    phone: "+91 9035254634",
    storeId: "71586578594",
    gmapLink:
      "https://www.google.com/maps/dir//Pilar+no+122,+GIVA+Silver+%26+Gold+Jewellery+%7C+Attapur+Hyderabad+%7C+Lab-Grown+Diamonds,+Shop+No.+1%262,+H.+No.+4-3-144%2F2,+Somi+Reddy+Nagar,+Attapur,+Hyderabad,+Telangana+500048/@17.3706818,78.4296073,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bcb9798023d8bb5:0xd0e5a4c05315001e!2m2!1d78.4296073!2d17.3706818!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - KONDAPUR HS",
    address:
      "1-112/SP/53/5/G, Solitaire Plaza, Kondapur, Serilingampally Mandal, Ranga Reddy District, Telangana 500084",
    phone: "+91 9035053675",
    storeId: "70239256738",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Kondapur+%7C+Lab+Grown+Diamonds,+Solitaire+Plaza,+Kondapur,+Serilingampalle+(M),+Hyderabad,+Telangana+500084/@17.4672827,78.3672639,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bcb91766bde81e3:0x2e7a7f896cea2a23!2m2!1d78.3672639!2d17.4672827!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - MALHAR ROAD HS",
    address: "28F Gurdev Nagar Malhar Road, Ludhiana- 141001",
    phone: "+91 9035254635",
    storeId: "70471057570",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Malhar+Road+Ludhiana+%7C+Lab+Grown+Diamonds,+28F,+Sat+Paul+Mittal+Rd,+Gurdev+Nagar,+Ludhiana,+Punjab+141001/@30.8952366,75.8221918,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x391a83339fbe3129:0x3267ba0508045bb8!2m2!1d75.8221918!2d30.8952366!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - VIRAR WEST",
    address:
      "\n      Shop 13, Global City, BLU PEARL, Chikhaldongari Road, Dongarpada, Rustomjee Global City, Virar West, Virar,\n      Maharashtra - 401303\n    ",
    phone: "+91 9035254631",
    storeId: "70239158434",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Virar+West+%7C+Lab+Grown+Diamonds,+Global+City,+BLU+PEARL,+Chikhaldongari+Rd,+Evershine+Globle+City,+Dongarpada,+Rustomjee,+Virar+West,+Mumbai,+Virar,+Maharashtra+401303/@19.4710032,72.804122,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3be7abdb74a638cb:0xa8833368103a3cac!2m2!1d72.8041066!2d19.4710874!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - MG ROAD HYD HS",
    address:
      "1-7-293/1/A, Groound Floor, Mahatma Gandhi Road, Kalasiguda, Secunderabad, Telangana -500003",
    phone: "+91 9108961302",
    storeId: "70239223970",
    gmapLink:
      "https://www.google.com/maps/dir//Ground+Floor,+GIVA+Silver+%26+Gold+Jewellery+%7C+MG+Road+Hyderabad+%7C+Lab-Grown+Diamonds,+1-7-293%2F1%2FA,+Mahatma+Gandhi+Rd,+Kalasiguda,+Hyderabad,+Secunderabad,+Telangana+500003/@17.4413904,78.4878799,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bcb9b0072ca9665:0x644fe9133401fd83!2m2!1d78.4879958!2d17.4410688!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Mathikere HS",
    address:
      "#25/7, HMT Main Road, Mathikere Extension, Bengaluru 560054 Karnataka",
    phone: "+91 9035254637",
    storeId: "70239060130",
    gmapLink:
      "https://www.google.com/maps/dir//25%2F7,+GIVA+-+Bangalore+-+Mathikere,+HMT+Main+Rd,+Gokula+1st+Stage,+Mathikere+Extension,+Mathikere,+Bengaluru,+Karnataka+560054/@13.0307806,77.5600104,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae3d4967897a4d:0x9e9519408c9ec77d!2m2!1d77.5600104!2d13.0307806!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - VIP ROAD SURAT",
    address:
      "\n      Shop no 35, Espace, VIP Road, Near Khatu Shyam Temple, Opp. Essar Petrol Pump, Bharthana, Surat- 395007 Gujarat\n    ",
    phone: "+91 9035254632",
    storeId: "71524024482",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+no+35,+Espace,+GIVA+Silver+%26+Gold+Jewellery+%7C+VIP+Road+Surat+%7C+Lab+Grown+Diamonds,+VIP+Road,+near+Khatu+Shyam+Temple,+opp.+Essar+Petrol+Pump,+Bharthana,+Surat,+Gujarat+395007/@21.1433697,72.7946605,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3be053840ad86755:0x72b6c541387ce318!2m2!1d72.7946605!2d21.1433697!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Elan Mall",
    address:
      "Shop no: G – 74, 74 A, 75, 75 A, Sector 84, Gurugram- 122004 Haryana",
    phone: "+91 9035053671",
    storeId: "69589368994",
    gmapLink:
      "https://www.google.com/maps/dir//074A,+75,+75A,+Giva+-+Gurgaon+-+Elan+Mall,+Elan+Miracle+Mall,+GF-074,+Northern+Peripheral+Rd,+Sector+84,+Gurugram,+Haryana+122001/@28.4038223,76.965005,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390d3d00255a48a3:0xf26ed0b0c0d68019!2m2!1d76.9637035!2d28.4150698!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Nallagandla",
    address:
      "Plot no 127 Nallagandla, Village, Serilingampally Mandal, Ranga Reddy District, Hyderabad 500019 Telangana",
    phone: "+91 9035254636",
    storeId: "69969084578",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Nallagandala+%7C+Lab+Grown+Diamonds,+Plot+no+127+Nallagandla,+Serilingampalle+(M),+Hyderabad,+Telangana+500019/@17.4775419,78.3080434,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bcb93d1d73a60cd:0x29645120cb7cbf76!2m2!1d78.3080434!2d17.4775419!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Neeladri HS",
    address:
      "\n      Badri Complex, No. 353/156/154,Ground floor, 13th cross corner Bldg, Neeladrinagar Main Road Electronics City\n      Phase 1, Bengaluru- 560100 Karnataka\n    ",
    phone: "+91 9035254650",
    storeId: "71638843554",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Neeladri+%7C+Lab+Grown+Diamonds,+corner+Building,+Badri+Complex,+Ground+floor,+13th+cross,+Main+Road,+Neeladri+Nagar,+Electronics+City+Phase+1,+Bengaluru,+Karnataka+560100/@12.8415701,77.647172,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae6b39ecd3f5d7:0xf54aef91400c5f3d!2m2!1d77.647172!2d12.8415701!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - GVK ONE MALL",
    address:
      "Shop 19, Second Floor, GVK ONE MALL, Road No. 1 Banjara Hills, Hyderabad- 500034 Telangana",
    phone: "+91 9035254643",
    storeId: "71638876322",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+19,+Second+Floor,+GIVA+Silver+%26+Gold+Jewellery+%7C+GVK+1+Mall+%7C+Lab+Grown+Diamonds,+Gvk+One+Mall,+Rd+Number+1,+Balapur+Basthi,+Banjara+Hills,+Hyderabad,+Telangana+500034/@17.4191704,78.4486398,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bcb97bd544d694b:0x2746d7381d13586c!2m2!1d78.4486398!2d17.4191704!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Canada Corner HS",
    address:
      "3-4, Kamal Shopping Center, Sharanpur Rd, Canada Corner, Nashik- 422002 Maharashtra",
    phone: "+91 9035254645",
    storeId: "71638712482",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Nashik+%7C+Lab+Grown+Diamonds,+Kamal+Shopping+Center,+3-4,+Sharanpur+Rd,+Opp.+Telephone+Exchange,+Canada+Corner,+Nashik,+Maharashtra+422002/@20.0026958,73.7714074,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bddeb119687b955:0xa04c73dd03f93a60!2m2!1d73.7714074!2d20.0026958!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Mumbai Naka HS",
    address:
      "\n      Shop 2, Mumbai House, Opp Kalika Mata Mandir, Shingada Talav, Mumbai Naaka, Renuka Nagar, Nashik- 422009\n      Maharashtra\n    ",
    phone: "+91 9035254638",
    storeId: "71638810786",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+2,+GIVA+Silver+%26+Gold+Jewellery+%7C+Nashik+Mumbai+Nakka+%7C+Lab+Grown+Diamonds,+Mumbai+House,+opp.+Kalika+Mata+Mandir,+Shingada+Talav,+Mumbai+Naka,+Renuka+Nagar,+Nashik,+Maharashtra+422009/@19.9906754,73.7828101,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bddeb4a356fcc7d:0xfe4e939e87e54894!2m2!1d73.7828101!2d19.9906754!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - KR PURAM HS",
    address:
      "15 Ground Floor,Survey No.415, Monarch Aqua, Krishnarajapuram, Old Madras Road, Bengaluru 560001 Karnataka",
    phone: "+91 9035254626",
    storeId: "69154177186",
    gmapLink:
      "https://www.google.com/maps/dir//Ground+Floor,Survey+No.415,+GIVA+Silver+%26+Gold+Jewellery+%7C+KR+Puram+%7C+Lab+Grown+Diamonds,+Monarch+Aqua,+15,+Old+Madras+Rd,+Venkateshwara+Layout,+Chikkabasavanapura,+Krishnarajapuram,+Bengaluru,+Karnataka+560001/@13.0152205,77.701658,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae114cfd75f6f7:0x302811f165a567ac!2m2!1d77.701658!2d13.0152205!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - LINKING ROAD BANDRA HS",
    address:
      "\n      499, SN 11 &amp; 12, GF, Swarna Rekha Bldg, Telephone Exchange, Linking Rd, opposite Khar, Khar West, Mumbai- 400052\n      Maharashtra\n    ",
    phone: "+91 9035254644",
    storeId: "68003037346",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Bandra+-+Linking+Road+%7C+Lab+Grown+Diamonds,+Swarna+Rekha+Bldg,+Telephone+Exchange+Linking+Rd,+opposite+Khar,+Khar,+West,+Bandra+West,+Mumbai,+Maharashtra+400052/@19.0668176,72.8337649,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3be7c931c7dd5185:0xe523172b61ec4c0e!2m2!1d72.8337649!2d19.0668176!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Mogappir HS",
    address:
      "HIG-1 4/1397 &amp; 1398, PHASE 1, NOLAMBUR, CHENNAI 600037 Tamil Nadu",
    phone: "+91 9035254639",
    storeId: "71692484770",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Mogappir+%7C+Lab+Grown+Diamonds,+Phase-1,+4th+Block,+Nolambur,+Mogappair,+Chennai,+Tamil+Nadu+600037/@13.082011,80.1685302,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3a5261053f3502d3:0x56cd7a0340985ab3!2m2!1d80.1685302!2d13.082011!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - BELAPUR HS",
    address:
      "Shop 26 &amp; 27 Mahavir Rachna, Plot 54, Sector 15, CBD Belapur, Mumbai, Navi Mumbai- 400614 Maharashtra",
    phone: "+91 9035254627",
    storeId: "70239125666",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+26+%26+27,+GIVA+Silver+%26+Gold+Jewellery+%7C+Belapur+%7C+Lab+Grown+Diamonds,+Mahavir+Rachna,+Plot+54,+Sector+15,+CBD+Belapur,+Mumbai,+Navi+Mumbai,+Maharashtra+400614/@19.0107808,73.0333775,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3be7c34bf102aaad:0x736e92b218c0af49!2m2!1d73.0333775!2d19.0107808!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Zirakpur HS",
    address:
      "Unit no. 4, Opp Cosmo Mall, Chandigarh, Ambala Highway, Zirakpur- 140603 Punjab",
    phone: "+91 9035254649",
    storeId: "69604802722",
    gmapLink:
      "https://www.google.com/maps/dir//Unit+no.+4,+GIVA+Silver+%26+Gold+Jewellery+%7C+Zirakpur+%7C+Lab+Grown+Diamonds,+Ambala+-+Chandigarh+Expy,+opp.+Cosmo+Mall,+Zirakpur,+Chandigarh,+Punjab+140603/@30.6372698,76.8234332,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390feb1e8f2c0fcb:0x2c7899d2d8c49b83!2m2!1d76.8234332!2d30.6372698!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Anishabad HS",
    address: "S-2, Ali Nagar colony, Anishabad, Phulwari, Patna- 800002 Bihar",
    phone: "+91 9108432656",
    storeId: "71735214242",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Anishabad+%7C+Lab+Grown+Diamonds,+S-2,+Ali+Nagar+colony,+Anishabad,+Phulwari+Sharif,+Patna,+Bihar+800002/@25.5840177,85.0928264,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x39ed5797602116f9:0xec7b2dbb9cc2b3c1!2m2!1d85.0928264!2d25.5840177!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - GOOD EARTH 69",
    address:
      "Unit No. 5 &amp; 33, Good Earth 69, Sector 69,Gurugram- 122001 Haryana",
    phone: "+91 9035254628",
    storeId: "69555191970",
    gmapLink:
      "https://www.google.com/maps/dir//Unit+No.+5+%26+33,+GIVA+Silver+%26+Gold+Jewellery+%7C+Good+Earth+69+%7C+Lab+Grown+Diamonds,+Good+Earth+69,+Sector+69,+Gurugram,+Haryana+122001/@28.395313,77.039313,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390d2325ed0fb149:0x70ee312b1ce659ae!2m2!1d77.039313!2d28.395313!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Tambaram HS",
    address: "No 165, New No26, GST Road,Tambaram Chennai- 600045 Tamil Nadu",
    phone: "+91 9035271612",
    storeId: "71918387362",
    gmapLink:
      "https://www.google.com/maps/dir//No+165,+GIVA+Silver+%26+Gold+Jewellery+%7C+Tambaram+%7C+Lab+Grown+Diamonds,+New+No26,+Grand+Southern+Trunk+Rd,+RV+Garden,+Tambaram,+Chennai,+Tamil+Nadu+600045/@12.9336067,80.1244318,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3a525f46aa863347:0xee4e74f0b894317d!2m2!1d80.1244318!2d12.9336067!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Boring Canal HS",
    address:
      "\n      Property No. 2139908, Revenue Circle 249, New Holding, Old Holding 610A, West Boring Canal Road, Near of P.M.C\n      Sump House, Patna- 800001 Bihar\n    ",
    phone: "+91 9035271613",
    storeId: "71993098402",
    gmapLink:
      "https://www.google.com/maps/dir//Holding,+Old+Holding+610A,+GIVA+Silver+%26+Gold+Jewellery+Store+%7C+Boring+Road+Patna,+Revenue+Circle,+Property+No.+2139908,+249+New,+West+Boring+Canal+Rd,+Patna,+Bihar+800001/@25.6117679,85.1182275,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x39ed59f71bd18013:0xa18808bd8e7e5385!2m2!1d85.1182275!2d25.6117679!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - APOLLO Mall",
    address:
      "\n      Apollo High street, unit no- C3,4,25,26, Sector F, Slice 3, Aranya Nagar scheme,78, Vijay Nagar, Indore- 452010\n      Madhya Pradesh\n    ",
    phone: "+91 9035271614",
    storeId: "72011153570",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Apollo+Indore+%7C+Lab+Grown+Diamonds,+Apollo+High+street,+Sector+F,+Slice+3,+Aranya+Nagar,+Scheme+78,+Vijay+Nagar,+Indore,+Madhya+Pradesh+452010/@22.7660044,75.8989916,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x396303005052ad37:0xbe32dd034ac8d4cb!2m2!1d75.8989948!2d22.7660289!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Sector 31 Gurugram HS",
    address: "Ground Floor - SCO-15, Sector 31, Gurugram 122001 Haryana",
    phone: "+91 9035281621",
    storeId: "71992443042",
    gmapLink:
      "https://www.google.com/maps/dir//Ground+Floor,+GIVA+-+Gurgaon+-+Sector+31,+SCO-15,+Sector+31,+Gurugram,+Haryana+122001/@28.45503,77.055787,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390d192e32ae96fd:0xef11bfb7bd69739b!2m2!1d77.0501178!2d28.4529796!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - RACE COURSE ROAD HS",
    address:
      "GF Unit No.1, Ocean Sarabhai Road, Opp. Vadodara Central Mall Vadiwadi, Vadodara, Gujarat, 390012",
    phone: "+91 9035281620",
    storeId: "70239387810",
    gmapLink:
      "https://www.google.com/maps/dir//GF+Unit+No.1,+GIVA+Silver+%26+Gold+Jewellery+%7C+Race+Course+Road+%7C+Lab+Grown+Diamonds,+Ocean,+Sarabhai+Rd,+opp.+Vadodara+Central+Mall,+Vadiwadi,+Vadodara,+Gujarat+390012/@22.3161121,73.1706854,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x395fc9b50f5aade1:0xc03a70205c3d068!2m2!1d73.169229!2d22.3176058!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - TOLICHOWKI HS",
    address:
      "Shop No.4, GF, M.No. 8-1-346/1/g-4, Liberty Plaza, Tolichowki, Shaikpet Village, Hyderabad- 500008 Telangana",
    phone: "+91 9035281616",
    storeId: "72011120802",
    gmapLink:
      "https://www.google.com/maps/dir//UG+-+4,+GIVA+Silver+%26+Gold+Jewellery+%7C+Tolichowki+Hyderabad+%7C+Lab+Grown+Diamonds,+Liberty+Plaza,+8-1-346%2F1,+Sabza+Colony,+Ambedkar+Nagar,+Toli+Chowki,+Hyderabad,+Telangana+500008/@17.404667,78.4070744,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bcb97e3bcd1bacd:0x27d1d99672dedb7f!2m2!1d78.4070744!2d17.404667!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Alambagh Market HS",
    address:
      "A-104, Sector B, Kanpur Road, Alambagh Market, Lucknow - 226005 Uttar Pradesh",
    phone: "+91 9035254633",
    storeId: "68866375842",
    gmapLink:
      "https://www.google.com/maps/dir//GIVA+Silver+%26+Gold+Jewellery+%7C+Alambagh+Market+%7C+Lab+Grown+Diamonds,+A-104,+Kanpur+Rd,+Sector+B,+Market,+Alambagh,+Lucknow,+Uttar+Pradesh+226005/@26.796374,80.8979355,15z/data=!4m9!4m8!1m0!1m5!1m1!1s0x399bff5aea26c1fd:0x35ddccf53f92dcd1!2m2!1d80.8979355!2d26.796374!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Royal Meenakshi Mall",
    address:
      "\n      GF G005 ROYAL MEENAKSHI MALL, Bannerghatta Main Road, Hulimavu Ward, Bruhat Bangalore Mahanagarapalike - Arakere\n      Sub-Division, Bengaluru - 560076\n    ",
    phone: "+91 9035281617",
    storeId: "71992410274",
    gmapLink:
      "https://www.google.com/maps/dir//F+G005,+GIVA+Silver+%26+Gold+Jewellery+Store+%7C+Royal+Meenakshi+Mall+Bangalore,+Royal+Meenakshi+Mall,+Bannerghatta+Rd,+Hulimavu,+Bengaluru,+Karnataka+560076/@12.8757228,77.5958428,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae6be05a76cb4d:0x20c6fae05f921c07!2m2!1d77.5958428!2d12.8757228!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - M5 Mall",
    address:
      "M5 Mall, Veerasandra Industrial Area, Electronic City, Bengaluru 560100 Karnataka",
    phone: "+91 8310190554",
    storeId: "72207827106",
    gmapLink:
      "https://www.google.com/maps/dir//Giva+-+Bangalore+-+M5+Mall,+Gopalan+gardenia,+M5+Mall,+Industrial+Area,+Electronic+City,+Bengaluru,+Karnataka+560100/@12.8418476,77.676855,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae6de59dfde595:0xb2448a0d3862448a!2m2!1d77.676855!2d12.8418476!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - RCUBE Monad",
    address:
      "RCUBE Monad Mall Plot No. A-267/1 to A-267/4, located at Sector 43, Noida, Uttar Pradesh 201301",
    phone: "+91 9035380941",
    storeId: "71992606882",
    gmapLink:
      "https://www.google.com/maps/dir//Giva+-+Noida+-+RCUBE+Monad+Mall,+RCUBE+Monad+Mall,+Plot+No.+A-267%2F1+to+A-267%2F4,+Block+A,+Sector+43,+Noida,+Uttar+Pradesh+201301/@28.5608093,77.3564696,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390ce50358448b63:0x76ae20b96ea6c99a!2m2!1d77.3564696!2d28.5608093!3e0?entry=ttu&g_ep=EgoyMDI1MDIwNS4xIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Kothapet HS",
    address:
      "Survey No. 9/1, Plot no. A1, 11-14-3, Kothapet, Saroornagar, Hyderabad- 500035 Telangana",
    phone: "+91 9035380938",
    storeId: "71992311970",
    gmapLink:
      "https://www.google.com/maps/dir//Giva+-+Hyderabad+-+Kothapet,+11-14-3,+Plot+no.+A1,+Saroornagar,+Kothapet,+Hyderabad,+Telangana+500035/@17.3586815,78.5450715,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bcb99d7162b56f3:0xfd4e38e0fe6c00a9!2m2!1d78.5450715!2d17.3586815!3e0?entry=ttu&g_ep=EgoyMDI1MDIxMC4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - HSR Layout 2",
    address:
      "No. 1134, Avani Avenue, 17th Cross, Sector 7, HSR Layout, Bengaluru- 560102 Karnataka",
    phone: "+91 9035380951",
    storeId: "72011219106",
    gmapLink:
      "https://www.google.com/maps/dir//No.+1134,+Giva+-+Bangalore+-+Sector+7+HSR+Layout,+Avani+Avenue,+17th+Cross+Rd,+Sector+7,+HSR+Layout,+Bengaluru,+Karnataka+560102/@12.9121378,77.6337912,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae15005c1fcc7b:0x965ef8c03a6844e6!2m2!1d77.6337912!2d12.9121378!3e0?entry=ttu&g_ep=EgoyMDI1MDIxMC4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - SECTOR 104 HS",
    address:
      "Plot 104, Block HA, Sector 104, Gautam Budh Nagar, Noida 201301 UP",
    phone: "+91 9035380940",
    storeId: "72413184162",
    gmapLink:
      "https://www.google.com/maps/dir//Giva+-+Noida+-+SECTOR+104,+Plot+104,+Block+A,+Sector+104,+Noida,+Uttar+Pradesh+201301/@28.5396488,77.3662709,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390ce55176821ac7:0xeeb1bd2dc4a1239a!2m2!1d77.3662709!2d28.5396488!3e0?entry=ttu&g_ep=EgoyMDI1MDIxMC4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Banjara Hills HS",
    address:
      "\n      Shop No. D &amp; D-1, on Ground Floor, in “G.S. Plaza”, Municipal No. 8-2-672, Road No. 1, Banjara Hills - 500036\n      Hyderabad\n    ",
    phone: "+91 9035380950",
    storeId: "72413249698",
    gmapLink:
      "https://www.google.com/maps/dir//Municipal+No.+8,+Giva+-+Hyderabad+-+Banjara+Hills,+GS+Plaza,+D-1,+Ground+Floor,+2-672,+Banjara+Hills+Rd+Number+1,+Hyderabad,+Telangana+500036/@17.4097209,78.4500253,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bcb97a4432b11e3:0xa0f1df71f2a32951!2m2!1d78.4500253!2d17.4097209!3e0?entry=ttu&g_ep=EgoyMDI1MDIxMC4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Circular Rd",
    address:
      "Shop No. G1, H Square Mall, Circular Road, Part A, Lalpur, Ranchi, Jharkhand 834001",
    phone: "+91 9035281619",
    storeId: "72231682210",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+No.+G1,+Giva+-+Ranchi+-+Circular+Road,+H+Square+Mall,+Circular+Rd,+Part+A,+Lalpur,+Ranchi,+Jharkhand+834001/@23.370619,85.3394306,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x39f4e10049b4fadd:0x3811bcfc0f79cb7e!2m2!1d85.3394306!2d23.370619!3e0?entry=ttu&g_ep=EgoyMDI1MDIxMC4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Tribecca",
    address:
      "Unit/Shop bearing No S-71 on Plaza Floor, Tribeca Highstreet, NIBM Road, Pune Pin code- 411060",
    phone: "+91 9035380942",
    storeId: "71992377506",
    gmapLink:
      "https://www.google.com/maps/dir//on+Plaza+Floor,+Giva+-+Pune+-+Tribecca+NIBM+Road,+Tribeca+Highstreet,+S-71,+NIBM+Rd,+Kondhwa,+Pune,+Maharashtra+411060/@18.4766733,73.9084833,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bc2eb8d87c0c60f:0xfdf6f1562bde4756!2m2!1d73.9084833!2d18.4766733!3e0?entry=ttu&g_ep=EgoyMDI1MDIxMC4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Karelibagh HS",
    address:
      "Earth Euphoria Shop 6 &amp; 106, New VOP Road, Circle, Near VUDA Bhavan, Karelibagh, Vadodara, Gujarat 390002",
    phone: "+91 9036993763",
    storeId: "71735247010",
    gmapLink:
      "https://www.google.com/maps/dir//Shop+6+%26+106,+Giva+-+Vadodara+-+Karelibagh,+Earth+Euphoria,+New,+VIP+Rd,+near+VUDA+Bhavan,+Amit+Nagar,+Veer+Nagar+1,+Karelibagh,+Vadodara,+Gujarat+390002/@22.3256274,73.1988835,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x395fcf7ef00b99e9:0x84cef1c11223553b!2m2!1d73.1988835!2d22.3256274!3e0?entry=ttu&g_ep=EgoyMDI1MDIxMC4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Marathahalli 2",
    address:
      "No: 205, ACR Greens, Outer Ring Road, Munnekolalu, Marathahalli, Bangalore 560037 Karnataka",
    phone: "+91 9036993776",
    storeId: "72650490018",
    gmapLink:
      "https://www.google.com/maps/dir//Giva+-+Bangalore+-+ACR+Greens,+Marathalli,+No:+205,+ACR+Greens,+Outer+Ring+Road,+Munnekolalu,+Marathahalli,+Bengaluru,+Karnataka+560037/@12.9522379,77.7002283,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x3bae175c738a2c01:0x2fdd23443907a04f!2m2!1d77.7002283!2d12.9522379!3e0?entry=ttu&g_ep=EgoyMDI1MDIxMC4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    name: "GIVA - Saguna More HS",
    address:
      "Plot 97, Khata No. 130, Opposite HITEC, H Hospital Khagaul Road, Saguna More, Danapur , Patna 801503 Bihar",
    phone: "+91 9035281625",
    storeId: "72232042658",
    gmapLink:
      "https://www.google.com/maps/dir//Khata+No.+130,+Giva+-+Patna+-+Saguna+More,+Plot+97,+Saguna+Khagaul+Rd,+opposite+HITECH+Hospital,+Saguna+More,+Kaliket+Nagar,+Danapur,+Patna,+Bihar+801503/@25.6210369,85.0417225,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x39ed57c2e0956f19:0x1ca20a4affa673cb!2m2!1d85.0417225!2d25.6210369!3e0?entry=ttu&g_ep=EgoyMDI1MDIxMC4wIKXMDSoASAFQAw%3D%3D",
  },
];

let sheetores = [
  "66203910306",
  "67372253346",
  "67055648930",
  "67513680034",
  "67953623202",
  "66245132450",
  "67055812770",
  "66829910178",
  "67055583394",
  "67918987426",
  "67357376674",
  "67918921890",
  "66245165218",
  "67933601954",
  "67564568738",
  "67961225378",
  "67652911266",
  "67652976802",
  "67923247266",
  "67513581730",
  "67652878498",
  "67923280034",
  "67933569186",
  "67961290914",
  "66499379362",
  "67513516194",
  "67933634722",
  "67962667170",
  "67985834146",
  "67976429730",
  "67976396962",
  "67979018402",
  "67978657954",
  "67992486050",
  "67992420514",
  "67994419362",
  "68003004578",
  "68003528866",
  "68014375074",
  "68013588642",
  "68002939042",
  "68019650722",
  "68026794146",
  "68002971810",
  "68003594402",
  "68024565922",
  "67978625186",
  "68025647266",
  "68024631458",
  "68029087906",
  "68026826914",
  "68029743266",
  "68026433698",
  "68049043618",
  "68037410978",
  "68046323874",
  "68054843554",
  "68066934946",
  "68066967714",
  "68057694370",
  "68014702754",
  "67992453282",
  "68058480802",
  "68064706722",
  "68084596898",
  "68071719074",
  "68088103074",
  "68088135842",
  "68053041314",
  "68096458914",
  "68094623906",
  "68076535970",
  "68094591138",
  "68083843234",
  "68161732770",
  "68003496098",
  "68099932322",
  "68230414498",
  "68099965090",
  "68224352418",
  "68273143970",
  "68227268770",
  "68272750754",
  "68224385186",
  "68323868834",
  "68616683682",
  "68670980258",
  "68046782626",
  "68076470434",
  "68460642466",
  "68272259234",
  "68692050082",
  "68460708002",
  "68706959522",
  "68641783970",
  "68460675234",
  "68692213922",
  "68475224226",
  "68773478562",
  "68483186850",
  "68766171298",
  "68058448034",
  "68037542050",
  "68526768290",
  "68803035298",
  "68444324002",
  "69154111650",
  "68997054626",
  "68676681890",
  "68956782754",
  "69154209954",
  "68049305762",
  "68866408610",
  "69273190562",
  "68323836066",
  "69341544610",
  "69321982114",
  "68049141922",
  "68069818530",
  "69218697378",
  "69662015650",
  "68046356642",
  "69961351330",
  "69321949346",
  "69896634530",
  "69589303458",
  "70239092898",
  "69860753570",
  "69806915746",
  "70229524642",
  "70098583714",
  "70229557410",
  "69682888866",
  "70239420578",
  "71586578594",
  "70239256738",
  "70471057570",
  "70239158434",
  "70239223970",
  "70239060130",
  "71524024482",
  "69589368994",
  "69969084578",
  "71638843554",
  "71638876322",
  "71638712482",
  "71638810786",
  "69154177186",
  "68003037346",
  "71692484770",
  "70239125666",
  "69604802722",
  "71735214242",
  "69555191970",
  "71918387362",
  "71993098402",
  "72011153570",
  "71992443042",
  "70239387810",
  "72011120802",
  "68866375842",
  "71992410274",
  "72207827106",
  "71992606882",
  "71992311970",
  "72011219106",
  "72413184162",
  "72413249698",
  "72231682210",
  "71992377506",
  "71735247010",
  "72650490018",
  "72232042658",
];

const sis = [
  {
    name: "GIVA - Shoppers Stop",
    address:
      "211D SV Rd, Zalawad Nagar, Ganga Vihar, Andheri West, Mumbai, Maharashtra 400058",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Shoppers+Stop/@19.1150743,72.8426492,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x7e9226b9a881a1c7!8m2!3d19.1150098!4d72.8426758",
    gmapLink2:
      "https://www.google.com/maps/dir//19.1150743,72.8426492/@19.1152022,72.7723684,12z",
  },
  {
    name: "GIVA - Shoppers stop Pavilion mall",
    address:
      "Pavilion Mall Old Session Court Road, Near, Fountain Chowk, Civil Lines, Ludhiana, Punjab 141001",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Shoppers+Stop/@30.915879,75.840822,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x767db6db48c7de25!8m2!3d30.915879!4d75.840822",
    gmapLink2:
      "https://www.google.com/maps/dir//30.915879,75.840822/@30.9158019,75.7707362,12z",
  },
  {
    name: "GIVA - Shoppers Stop CITY CENTER",
    address:
      "City Centre 2, Rajarat, MAR (North Extension), Dash Drone, AA IID, Newtown, Kolkata, West Bengal 700159",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Shoppers+Stop/@22.622178,88.4492389,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x423f859c29ae4bff!8m2!3d22.6221429!4d88.4492306",
    gmapLink2:
      "https://www.google.com/maps/dir//22.622178,88.4492389/@22.6223145,88.3793194,12z",
  },
  {
    name: "GIVA - Shoppers Stop",
    address:
      "\n      COMMERCE@MANTRI, GROUND FLOOR N.S, Bannerghatta Main Rd, NS Palya, BTM 2nd Stage, BTM Layout, Bengaluru, Karnataka\n      560076\n    ",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Shoppers+Stop/@12.9122244,77.6005178,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x78039ecf8eea3041!8m2!3d12.9122244!4d77.6005178",
    gmapLink2:
      "https://www.google.com/maps/dir//12.9122244,77.6005178/@12.912559,77.530405,12z",
  },
  {
    name: "GIVA - Shoppers Stop",
    address: "Vidhan Sabha Rd, Mowa, Raipur, Chhattisgarh 492007",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Shoppers+Stop/@21.2757802,81.6873234,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x38060746616405f6!8m2!3d21.2757802!4d81.6873234",
    gmapLink2:
      "https://www.google.com/maps/dir//21.2757802,81.6873234/@21.2756476,81.6175225,12z",
  },
  {
    name: "GIVA - Reliance trends",
    address: "39, Bungalow Rd, Kamla Nagar, Delhi, 110007",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/TRENDS/@28.6840467,77.2042004,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0xeb157408c86f966!8m2!3d28.6840467!4d77.2042004",
    gmapLink2:
      "https://www.google.com/maps/dir//28.6840467,77.2042004/@28.6842028,77.1342411,12z",
  },
  {
    name: "GIVA - Reliance Trends",
    address:
      "\n      D.No.3-1-262 Sarojini Devi Road, Patny Center, Shopping Mall, Beside Chennai, Kalasiguda, Secunderabad, Telangana\n      500003\n    ",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/TRENDS/@17.4402738,78.4934139,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0xdcda47f14571e30!8m2!3d17.4402807!4d78.4934152",
    gmapLink2:
      "https://www.google.com/maps/dir//17.4402738,78.4934139/@17.4402569,78.4232454,12z",
  },
  {
    name: "Shoppers Stop",
    address:
      "Shoppers Stop, Garuda Mall, Magrath Rd, Ashok Nagar, Bengaluru, Karnataka 560025",
    phone: "+91 7483029206",
    gmapLink1:
      "https://www.google.com/maps/place/Shoppers+Stop/@12.9699486,77.6073034,17z/data=!3m2!4b1!5s0x3bae168044f3b1e7:0x4d6cadca6c1dbb95!4m5!3m4!1s0x3bae16805b871b99:0xb97202c81fb3dafc!8m2!3d12.9699434!4d77.6094921",
    gmapLink2:
      "https://www.google.com/maps/dir//Shoppers+Stop,+Magrath+Rd,+Ashok+Nagar,+Bengaluru,+Karnataka+560025/@12.9699486,77.6073034,17z/data=!3m1!5s0x3bae168044f3b1e7:0x4d6cadca6c1dbb95!4m8!4m7!1m0!1m5!1m1!1s0x3bae16805b871b99:0xb97202c81fb3dafc!2m2!1d77.6094921!2d12.9699434",
  },
  {
    name: "Shoppers Stop",
    address:
      "Shoppers Stop, In Orbit Mall, New Link Road, Malad West, Mumbai, Maharashtra 400064",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Shoppers+Stop/@19.1722794,72.8329755,17z/data=!3m2!4b1!5s0x3be7b6589f477e19:0xa189ab3cb5fd26e0!4m5!3m4!1s0x3be7b6589a3022f7:0x846f5b67944893be!8m2!3d19.1722743!4d72.8351642",
    gmapLink2:
      "https://www.google.com/maps/dir//Shoppers+Stop,+In+orbit+Mall,+New+Link+Rd,+Malad+West,+Mumbai,+Maharashtra+400064/@19.1722794,72.8329755,17z/data=!3m1!5s0x3be7b6589f477e19:0xa189ab3cb5fd26e0!4m8!4m7!1m0!1m5!1m1!1s0x3be7b6589a3022f7:0x846f5b67944893be!2m2!1d72.8351642!2d19.1722743",
  },
  {
    name: "Shoppers Stop",
    address:
      "\n      ShoppersStop, UG Floor, SARATH CITY, CAPITAL MALL, WHITE FI, Gachibowli - Miyapur Rd, Kondapur, Telangana 500084\n    ",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Shoppers+Stop/@17.4579902,78.3623637,17z/data=!3m2!4b1!5s0x3bcb93c8595a7705:0x39e105c48b32bf99!4m5!3m4!1s0x3bcb934dc405e161:0xbb4ea3bd9f1dc116!8m2!3d17.4579851!4d78.3645524",
    gmapLink2:
      "https://www.google.com/maps/dir//Shoppers+Stop,+SARATH+CITY,+CAPITAL+MALL,+WHITE+FI,+Gachibowli+-+Miyapur+Rd,+Kondapur,+Telangana+500084/@17.4579902,78.3623637,17z/data=!3m1!5s0x3bcb93c8595a7705:0x39e105c48b32bf99!4m8!4m7!1m0!1m5!1m1!1s0x3bcb934dc405e161:0xbb4ea3bd9f1dc116!2m2!1d78.3645524!2d17.4579851",
  },
  {
    name: "Shoppers Stop",
    address:
      "Shoppers Stop, Viviana Mall, Eastern Express Highway, LaxmiNagar, Thane West, Thane, Maharashtra 400606",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Shoppers+Stop/@19.2079376,72.9691016,17z/data=!3m2!4b1!5s0x3be7b93f8a48595f:0x9ea45d89a263a0e5!4m5!3m4!1s0x3be7b94073cc9d69:0x9577fdcd041fbf4c!8m2!3d19.2079325!4d72.9712903",
    gmapLink2:
      "https://www.google.com/maps/dir//Shoppers+Stop,+Viviana+Mall,+next+to+Jupiter+Hospital,+opposite+Eastern+Express+Highway,+W,+Thane,+Maharashtra+400606/@19.2079376,72.9691016,17z/data=!3m1!5s0x3be7b93f8a48595f:0x9ea45d89a263a0e5!4m8!4m7!1m0!1m5!1m1!1s0x3be7b94073cc9d69:0x9577fdcd041fbf4c!2m2!1d72.9712903!2d19.2079325",
  },
  {
    name: "Shoppers Stop",
    address:
      "\n      Shoppers Stop Limited, Plot No-3B1, Adjacent to Rithala Metro Station, Twin District Centre-1, Rohini Sector-10,\n      New Delhi-110085\n    ",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Shoppers+Stop/@28.7199111,77.1079075,17z/data=!3m2!4b1!5s0x390d02abbbaa8967:0xb387ba76b0b7fcc2!4m5!3m4!1s0x390d014eede1a3cf:0x82c15fc784ab2fd!8m2!3d28.7199064!4d77.1100962",
    gmapLink2:
      "https://www.google.com/maps/dir//Shoppers+Stop,+Plot+No.3B1,+Twin+Dist.+Centre-1,+Sector-+10,+Rohini,+Adjacent+To+Rithala+Metro+Station,+Rohini,+New+Delhi,+Delhi+110085/@28.7199111,77.1079075,17z/data=!3m1!5s0x390d02abbbaa8967:0xb387ba76b0b7fcc2!4m8!4m7!1m0!1m5!1m1!1s0x390d014eede1a3cf:0x82c15fc784ab2fd!2m2!1d77.1100962!2d28.7199064",
  },
  {
    name: "Shoppers Stop",
    address:
      "Shoppers Stop,251, GVK One Mall Plot # 6-3, 01, Rd Number 1, Banjara Hills, Hyderabad, Telangana 500034",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Shoppers+Stop/@17.4188841,78.4463027,17z/data=!3m2!4b1!5s0x3bcb9738ba751225:0x4fe65e8d227233e7!4m5!3m4!1s0x3bcb9736978b9b8d:0x84d352dda31c1a6e!8m2!3d17.418879!4d78.4484914",
    gmapLink2:
      "https://www.google.com/maps/dir//Shoppers+Stop,+251,+GVK+One+Mall+Plot+%23+6-3,+01,+Rd+Number+1,+Banjara+Hills,+Hyderabad,+Telangana+500034/@17.4188841,78.4463027,17z/data=!3m1!5s0x3bcb9738ba751225:0x4fe65e8d227233e7!4m8!4m7!1m0!1m5!1m1!1s0x3bcb9736978b9b8d:0x84d352dda31c1a6e!2m2!1d78.4484914!2d17.418879",
  },
  {
    name: "Shoppers Stop",
    address:
      "\n      Shoppers Stop, MANTRI SQUARE,#1 SAMPIGE ROAD, BEFORE SAMPIGE THEATRE &amp; MANTRI GRE MALLESHWARAM. SOUTH1,Bengaluru -\n      560003\n    ",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/search/Shoppers+Stop,+MANTRI+SQUARE,%231+SAMPIGE+ROAD,+BEFORE+SAMPIGE+THEATRE+%26+MANTRI+GRE+++MALLESHWARAM.+SOUTH1,Bengaluru+-+560003/@12.9936465,77.5716809,18z/data=!3m1!4b1",
    gmapLink2:
      "https://www.google.com/maps/dir//Shoppers+Stop,+MANTRI+SQUARE,%231+SAMPIGE+ROAD,+BEFORE+SAMPIGE+THEATRE+%26+MANTRI+GRE+MALLESHWARAM.+SOUTH1,+Bengaluru,+560003/@12.9936465,77.5716809,18z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bae162301640001:0x5936fd1928eb8a4!2m2!1d77.570875!2d12.9917222",
  },
  {
    name: "Shoppers Stop",
    address:
      "Shoppers Stop,Logix City Centre Mall Plot no 58, Sector 32, Noida, Uttar Pradesh 201301",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Shoppers+Stop/@28.5742642,77.3514299,17z/data=!3m1!4b1!4m5!3m4!1s0x390ce5bdc41594f5:0x6e8c80d5e5ddd0c4!8m2!3d28.5742595!4d77.3536186",
    gmapLink2:
      "https://www.google.com/maps/dir//Shoppers+Stop,+Logix+City+Centre+Mall+Plot+no+58,+Sector+32,+Noida,+Uttar+Pradesh+201301/@28.5742642,77.3514299,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x390ce5bdc41594f5:0x6e8c80d5e5ddd0c4!2m2!1d77.3536186!2d28.5742595",
  },
  {
    name: "Shoppers Stop",
    address:
      "Shoppers Stop,Alladin Mansion, 1-11-251/1, Sardar Patel Rd, Begumpet, Hyderabad, Telangana 500034",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Shoppers+Stop/@17.4452543,78.4656088,15z/data=!4m5!3m4!1s0x0:0x1fef0695b6efa297!8m2!3d17.4452174!4d78.4658222",
    gmapLink2:
      "https://www.google.com/maps/dir/28.6162944,77.3685248/Shoppers+Stop,Alladin+Mansion,+1-11-251%2F1,+Sardar+Patel+Rd,+Begumpet,+Hyderabad,+Telangana+500034/@22.9622729,73.9347213,6z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x3bcb90a36eed11e3:0x1fef0695b6efa297!2m2!1d78.4658222!2d17.4452174",
  },
  {
    name: "Shoppers Stop",
    address:
      "\n      Shoppers stop Gaur City Mall (GCM) , Near Gaur City 1, Sector 4, Greater Noida, West, Noida Phase-2, Noida, Uttar\n      Pradesh 201308\n    ",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Shoppers+Stop/@28.605562,77.4291073,15z/data=!4m5!3m4!1s0x0:0x34f7352e7c4be424!8m2!3d28.605562!4d77.4291073",
    gmapLink2:
      "https://www.google.com/maps/dir//Shoppers+Stop,+Gaur+City+Mall+(GCM)+,+Near+Gaur+City+1,+Sector+4,+Greater+Noida,+West,+Noida+Phase-2,+Noida,+Uttar+Pradesh+201308/@28.605562,77.4291073,15z/data=!3m1!5s0x390cee53d4ac3be7:0xda8d9676b9b2641d!4m8!4m7!1m0!1m5!1m1!1s0x390cef41ecf4bf1d:0x34f7352e7c4be424!2m2!1d77.4291073!2d28.605562",
  },
  {
    name: "Pantaloons",
    address:
      "Pantaloons, Phoenix Market City, Whitefield Main Rd, opposite Bbmp Office, Bengaluru, Karnataka 560048",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Pantaloons+(Phoenix+Market+City,+Whitefield,+Bengaluru)/@12.9970855,77.6943385,17z/data=!3m1!4b1!4m5!3m4!1s0x3bae110afd9c434f:0xb72a337a8a5c8f35!8m2!3d12.9970803!4d77.6965272",
    gmapLink2:
      "https://www.google.com/maps/dir//Pantaloons+(Phoenix+Market+City,+Whitefield,+Bengaluru),+Phoenix+Market+City,+Whitefield+Main+Rd,+opposite+Bbmp+Office,+Bengaluru,+Karnataka+560048/@12.9970855,77.6943385,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bae110afd9c434f:0xb72a337a8a5c8f35!2m2!1d77.6965272!2d12.9970803",
  },
  {
    name: "Pantaloons",
    address:
      "\n      Pantaloons, Orchid Tower, 3/1 A, Upendra Chandra Banerjee Rd, Phool Bagan, Kankurgachi, Kolkata, West Bengal\n      700054\n    ",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Pantaloons+(Kankurgachi,+Kolkata)/@22.5751441,88.3872806,17z/data=!3m1!4b1!4m5!3m4!1s0x3a0277e740484a2f:0x5d63f5053d71e2fa!8m2!3d22.5751392!4d88.3894693",
    gmapLink2:
      "https://www.google.com/maps/dir//Pantaloons+(Kankurgachi,+Kolkata),+Orchid+Tower,+3%2F1+A,+Upendra+Chandra+Banerjee+Rd,+Phool+Bagan,+Kankurgachi,+Kolkata,+West+Bengal+700054/@22.5751441,88.3872806,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3a0277e740484a2f:0x5d63f5053d71e2fa!2m2!1d88.3894693!2d22.5751392",
  },
  {
    name: "Pantaloons",
    address:
      "Pantaloons, 5, Jawaharlal Nehru Rd, Noapara, Action Area IID, Rajarhat, Kolkata, West Bengal 700157",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Pantaloons+(City+Centre+-+2,+Kolkata)/@22.6227682,88.448308,17z/data=!3m2!4b1!5s0x39f89fdaa1e1fea1:0x22f27eff52e0644d!4m5!3m4!1s0x39f89f0e0e322f1d:0x2f547aa3b28199ef!8m2!3d22.6227633!4d88.4504967",
    gmapLink2:
      "https://www.google.com/maps/dir//Pantaloons+(City+Centre+-+2,+Kolkata),+5,+Jawaharlal+Nehru+Rd,+Noapara,+Action+Area+IID,+Rajarhat,+Kolkata,+West+Bengal+700157/@22.6227682,88.448308,17z/data=!3m1!5s0x39f89fdaa1e1fea1:0x22f27eff52e0644d!4m8!4m7!1m0!1m5!1m1!1s0x39f89f0e0e322f1d:0x2f547aa3b28199ef!2m2!1d88.4504967!2d22.6227633",
  },
  {
    name: "Pantaloons",
    address:
      "\n      Pantaloons, Store No.99, South City Mall, 375, Prince Anwar Shah Rd, South City Complex, PROJECT, Kolkata, West\n      Bengal 700068\n    ",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Pantaloons+(South+City+Mall,+Kolkata)/@22.5015168,88.3595343,17z/data=!3m2!4b1!5s0x3a0270d8dd65ff0d:0xf7345dc901329bf!4m5!3m4!1s0x3a0270d87d6d5845:0xcfc24ae25dbe15ca!8m2!3d22.5015119!4d88.361723",
    gmapLink2:
      "https://www.google.com/maps/dir//Store+No.99,+Pantaloons+(South+City+Mall,+Kolkata),+South+City+Mall,+375,+Prince+Anwar+Shah+Rd,+South+City+Complex,+PROJECT,+Kolkata,+West+Bengal+700068/@22.5015168,88.3595343,17z/data=!3m1!5s0x3a0270d8dd65ff0d:0xf7345dc901329bf!4m8!4m7!1m0!1m5!1m1!1s0x3a0270d87d6d5845:0xcfc24ae25dbe15ca!2m2!1d88.361723!2d22.5015119",
  },
  {
    name: "Pantaloons",
    address:
      "Pantaloons, Junction Mall, Recol Park, Durgapur, West Bengal 713216",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Pantaloons+Store/@23.5393999,87.2886525,17z/data=!3m2!4b1!5s0x39f7720f8d0b5111:0x6d532fd4a009392c!4m5!3m4!1s0x39f7720f93931961:0xe79ba127df73b485!8m2!3d23.539395!4d87.2908412",
    gmapLink2:
      "https://www.google.com/maps/dir//Pantaloons+Store,+Junction+Mall,+Recol+Park,+Durgapur,+West+Bengal+713216/@23.5393999,87.2886525,17z/data=!3m1!5s0x39f7720f8d0b5111:0x6d532fd4a009392c!4m8!4m7!1m0!1m5!1m1!1s0x39f7720f93931961:0xe79ba127df73b485!2m2!1d87.2908412!2d23.539395",
  },
  {
    name: "Pantaloons",
    address:
      "\n      Pantaloons, COSMOS MALL COSMOS MALL, 2ND MILE, Sevoke Rd, opp. STATE ELECTRICITY BOARD, Siliguri, West Bengal\n      734001\n    ",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/search/Pantaloons,+COSMOS+MALL+COSMOS+MALL,+2ND+MILE,+Sevoke+Rd,+opp.+STATE+ELECTRICITY+BOARD,+Siliguri,+West+Bengal+734001/@26.7454724,88.4318327,16z/data=!3m1!4b1",
    gmapLink2:
      "https://www.google.com/maps/dir//Pantaloons+(Cosmos+Mall,+Siliguri),+COSMOS+MALL+COSMOS+MALL,+2ND+MILE,+Sevoke+Rd,+opp.+STATE+ELECTRICITY+BOARD,+Siliguri,+West+Bengal+734001,+03532540812/@26.7454724,88.4318327,16z/data=!4m8!4m7!1m0!1m5!1m1!1s0x39e4415fadc1565f:0x469ed30d7f52ca4f!2m2!1d88.4335842!2d26.7387558",
  },
  {
    name: "Pantaloons",
    address:
      "Pantaloons, D4, Ring Rd, South Extension, Block E, South Extension II, New Delhi, Delhi 110049",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Pantaloons+(South+Extension,+New+Delhi)/@28.5682368,77.2198347,17z/data=!3m1!4b1!4m5!3m4!1s0x390ce388a860a211:0x9504874a1a66ebe8!8m2!3d28.5682288!4d77.2220234",
    gmapLink2:
      "https://www.google.com/maps/dir//Pantaloons+(South+Extension,+New+Delhi),+D4,+Ring+Rd,+South+Extension,+Block+E,+South+Extension+II,+New+Delhi,+Delhi+110049/@28.5682368,77.2198347,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x390ce388a860a211:0x9504874a1a66ebe8!2m2!1d77.2220234!2d28.5682288",
  },
  {
    name: "Pantaloons",
    address:
      "Pantaloons, Vinayak City Centre, 48/24, Sardar Patel Marg, Civil Lines, Prayagraj, Uttar Pradesh 211002",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Pantaloons+(Civil+Lines,+Prayagraj,+Uttar+Pradesh)/@25.4547208,81.8322683,17z/data=!3m2!4b1!5s0x399acac3404c65d1:0x1024a360c3d856c2!4m5!3m4!1s0x399acac45738c2a5:0xf5f536f64c8e2f4a!8m2!3d25.454716!4d81.834457",
    gmapLink2:
      "https://www.google.com/maps/dir//Pantaloons+(Civil+Lines,+Prayagraj,+Uttar+Pradesh),+Vinayak+City+Centre,+48%2F24,+Sardar+Patel+Marg,+Civil+Lines,+Prayagraj,+Uttar+Pradesh+211002/@25.4547208,81.8322683,17z/data=!3m1!5s0x399acac3404c65d1:0x1024a360c3d856c2!4m8!4m7!1m0!1m5!1m1!1s0x399acac45738c2a5:0xf5f536f64c8e2f4a!2m2!1d81.834457!2d25.454716",
  },
  {
    name: "Pantaloons",
    address:
      "Pantaloons, TREASURE ISLAND TREASURE ISLAND MALL, 11 TUKOGANJ, MAIN ROAD, Madhya Pradesh 452001",
    phone: "",
    gmapLink1:
      "https://www.google.com/maps/place/Pantaloons+(Treasure+Island+Mall,+Indore,+Madhya+Pradesh)/@22.7213681,75.8764801,17z/data=!3m1!4b1!4m5!3m4!1s0x3962fd57e3670e7f:0xf3e294c0c1d264a6!8m2!3d22.7213632!4d75.8786688",
    gmapLink2:
      "https://www.google.com/maps/dir//Pantaloons+(Treasure+Island+Mall,+Indore,+Madhya+Pradesh),+TREASURE+ISLAND+TREASURE+ISLAND+MALL,+11+TUKOGANJ,+MAIN+ROAD,+Madhya+Pradesh+452001/@22.7213681,75.8764801,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3962fd57e3670e7f:0xf3e294c0c1d264a6!2m2!1d75.8786688!2d22.7213632",
  },
];

window.addEventListener("load", function () {
  mainStores.forEach((store) => {
    if (!sheetores.includes(store.storeId)) {
      console.log(store);
    }
  });
  let storelist = document.querySelector(".store-list");
  mainStores.forEach((store) => {
    storelist.innerHTML += `<div class="store-address">
    <div class="outlet">
      <h3>${store.name}</h3>
    </div>
    <p>${store.address}</p>
    <p>Timings: 09:00 AM to 09:00 PM</p>
    <p>
      <img height="2" width="2" loading="lazy" src="https://www.giva.co/cdn/shop/t/148/assets/phone.png?v=51909833480018826071736760191"
      ><a href="tel:${store.phone}">${store.phone}</a>
    </p>
    <p id="distanceFromStore" class="distanceFromStore">
      <img height="2" width="2" loading="lazy" src="https://www.giva.co/cdn/shop/t/148/assets/distance.png?v=38388862505105775691736760187">
    </p>
    <div class="address-btns">
      <button id="store_id_btn" onclick="location.href='https://www.giva.co/pages/view-designs?store-id=${store.storeId}'">
        <img height="2" width="2" loading="lazy" src="https://www.giva.co/cdn/shop/t/148/assets/bag.png?v=75857089435134833421736760188">See Designs
      </button>
      <button
        class="navigate-btn"
        onclick="viewMaps('${store.gmapLink}')"
      >
        <img height="2" width="2" loading="lazy" src="https://www.giva.co/cdn/shop/t/148/assets/navigate.png?v=162489532773930612281736760188">Navigate
      </button>
    </div>
  </div>`;
  });
  sis.forEach((store) => {
    storelist.innerHTML += `<div class="store-address">
    <div class="outlet">
      <h3>${store.name}</h3>
    </div>
    <p>${store.address}</p>
    <p>Timings: 09:00 AM to 09:00 PM</p>
    <p id="distanceFromStore" class="distanceFromStore">
      <img height="2" width="2" loading="lazy" src="https://www.giva.co/cdn/shop/t/148/assets/distance.png?v=38388862505105775691736760187">
    </p>
    <div class="address-btns">
      <button onclick="share('${store.name}', '${store.gmapLink1}')">
        <img height="2" width="2" loading="lazy" src="https://www.giva.co/cdn/shop/t/148/assets/share.png?v=78042429309642561961736760188">Share
      </button>
      <button
        class="navigate-btn"
        onclick="viewMaps('${store.gmapLink2}')"
      >
        <img height="2" width="2" loading="lazy" src="https://www.giva.co/cdn/shop/t/148/assets/navigate.png?v=162489532773930612281736760188">Navigate
      </button>
    </div>
  </div>`;
  });

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(sortStoreWithDistance, showError);
  }

  document.getElementById("store-count").innerHTML =
    mainStores.length + sis.length;
});

function showError(error) {
  console.log(error);
  return;
}

let newList = [];
let prev_count;

function sortStoreWithDistance(position) {
  const userLat = (position.coords.latitude * Math.PI) / 180;
  const userLon = (position.coords.longitude * Math.PI) / 180;
  const stores = document.getElementsByClassName("store-address");
  newList = [];
  for (let i = 0; i < stores.length; i++) {
    if (stores[i].getElementsByTagName("button").length > 0) {
      const storeLink = stores[i]
        .getElementsByTagName("button")[1]
        .getAttribute("onclick");
      const regex = new RegExp("@(.*),(.*),");
      const lat_long_match = storeLink.match(regex);
      const lat = (lat_long_match[1] * Math.PI) / 180;
      const long = (lat_long_match[2] * Math.PI) / 180;
      const dlon = long - userLon;
      const dlat = lat - userLat;
      const a =
        Math.pow(Math.sin(dlat / 2), 2) +
        Math.cos(userLat) * Math.cos(lat) * Math.pow(Math.sin(dlon / 2), 2);
      const c = 2 * Math.asin(Math.sqrt(a));
      const r = c * 6371;
      const obj = {
        dis: r,
        store: stores[i],
      };
      newList.push(obj);
    }
  }
  newList.sort((a, b) => (a.dis > b.dis ? 1 : b.dis > a.dis ? -1 : 0));
  document.getElementsByClassName("store-list")[0].innerHTML = "";
  newList.forEach((e) => {
    document.getElementsByClassName("store-list")[0].append(e.store);
    e.store.getElementsByClassName("distanceFromStore")[0].innerHTML +=
      Math.round(e.dis) + " km from you";
    e.store.getElementsByClassName("distanceFromStore")[0].style.display =
      "flex";
  });
}

document.addEventListener("DOMContentLoaded", function () {
  document
    .getElementsByClassName("check-btn")[0]
    .addEventListener("click", async function () {
      let newstores = 0;
      if (document.getElementsByClassName("nostore")[0]) {
        if (
          document.getElementsByClassName("nostore")[0].style.display !== "none"
        ) {
          const elements = document.getElementsByClassName("nostore");
          elements[0].parentNode.removeChild(elements[0]);
        }
      }
      let filter = document
        .getElementsByClassName("inputArea")[0]
        .value.toUpperCase();
      await fetch("https://givadiva.co/v2/maps/storeLocator", {
        method: "POST",
        body: JSON.stringify({ custom_input: filter }),
        headers: { "Content-Type": "application/json" },
      })
        .then((e) => e.json())
        .then((e) => {
          const locationIds = e.data.map((e) => e.location_id);
          const stores = document.getElementsByClassName("store-address");
          for (let i = 0; i < stores.length; i++) {
            if (stores[i].querySelector("#store_id_btn")) {
              const storeId = stores[i]
                .querySelector("#store_id_btn")
                .getAttribute("onclick")
                .split("store-id=")[1]
                .split("'")[0];
              if (locationIds.includes(storeId)) {
                stores[i].style.display = "flex";
                newstores += 1;
              } else {
                stores[i].style.display = "none";
              }
            } else {
              const storeAddress = stores[i]
                .getElementsByTagName("p")[0]
                .textContent.toUpperCase();
              if (storeAddress.includes(filter)) {
                stores[i].style.display = "flex";
                newstores += 1;
              } else {
                stores[i].style.display = "none";
              }
            }
          }
          document.getElementById("store-count").innerHTML = newstores;
          if (newstores === 0) {
            let div = document.createElement("div");
            div.innerHTML =
              "We are unable to locate a store at the given location. Please try another location or explore our designs online and take advantage of our convenient shipping options.";
            div.setAttribute("class", "store-address nostore");
            document.getElementsByClassName("store-list")[0].appendChild(div);
          }
        });
    });
});

function viewMaps(url) {
  window.open(url, "_blank");
}

function share(name, url) {
  window.open(
    "https://api.whatsapp.com/send?text=" + name + " | " + url,
    "_blank"
  );
}
